webpackJsonp([0],{

/***/ 1751:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewInvoice_vue__ = __webpack_require__(1752);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55d98efa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewInvoice_vue__ = __webpack_require__(1764);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55d98efa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1752:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InvoiceScreen__ = __webpack_require__(1756);
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    InvoiceScreen: __WEBPACK_IMPORTED_MODULE_0__InvoiceScreen__["a" /* default */]
  },
  data: function data() {
    return {
      invoiceData: {
        items: [],
        rate: 2,
        totalAmount: 0,
        buyerId: null
      }
    };
  },

  methods: {
    reset: function reset() {
      this.invoiceData = {
        items: [{
          type: 'Gold',
          subType: 'Chain',
          weight: 12.45,
          quantity: 2,
          currentValue: 12.34,
          principalValue: 123.2,
          buyerId: this.buyerId
        }, {
          type: 'Silver',
          subType: 'Ring',
          weight: 22.45,
          quantity: 2,
          currentValue: 12.34,
          principalValue: 153.2,
          buyerId: this.buyerId
        }],
        rate: 2,
        totalAmount: 276.4,
        buyerId: this.buyerId
      };
    }
  }
});

/***/ }),

/***/ 1753:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AddItem__ = __webpack_require__(1759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PrintInvoice__ = __webpack_require__(1761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_pdfmake__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils___ = __webpack_require__(47);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AddItem: __WEBPACK_IMPORTED_MODULE_8__AddItem__["a" /* default */],
    PrintInvoice: __WEBPACK_IMPORTED_MODULE_9__PrintInvoice__["a" /* default */]
  },
  props: {
    isSummary: {
      type: Boolean,
      default: false
    },
    invoiceData: {
      type: Object,
      default: function _default() {
        return {
          items: [],
          rate: 2,
          totalAmount: 0,
          buyerId: null
        };
      }
    },
    buyerId: String,
    mode: Number
  },
  data: function data() {
    return {
      formIsValid: true,
      dialog: false,
      gstInvoice: false,
      isEditItems: false,
      isUserBuyer: null,
      duplicateError: null,
      items: this.invoiceData.items || [],
      totalTradeDiscount: this.invoiceData.totalTradeDiscount || 0,
      editedIndex: -1,
      editedItem: {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        basicPrice: 0,
        GSTValue: 0,
        totlePrice: 0,
        tradeDiscount: 0,
        expiryDate: new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10),
        manufacturingDate: new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10),
        batchNumber: 'DEFAULT'
      },
      defaultItem: {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        basicPrice: 0,
        GSTValue: 0,
        totlePrice: 0,
        tradeDiscount: 0,
        expiryDate: new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10),
        manufacturingDate: new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10),
        batchNumber: 'DEFAULT'
      },
      amountFromCash: this.invoiceData.amountFromCash || 0,
      amountFromBank: this.invoiceData.amountFromBank || 0,
      alertDuration: this.invoiceData.duration || 0,
      paymentType: this.invoiceData.paymentType || "",
      selectedFirm: this.invoiceData.firm || "",
      selectedBank: this.invoiceData.bank || "",
      soldBy: this.invoiceData.soldBy || '',
      brokerageRate: this.invoiceData.brokerageRate || 0,
      // godawnBy : this.invoiceData.godawnBy || '',
      placeOfSupply: this.invoiceData.placeOfSupply || '',
      invoiceDate: this.invoiceData.date ? new Date(this.invoiceData.date).toISOString().substr(0, 10) : new Date().toISOString().substr(0, 10),
      dateFormatted: this.invoiceData.date ? new Date(this.invoiceData.date).toISOString().substr(0, 10) : new Date().toISOString().substr(0, 10),
      datepicker: false,
      totalAmount: this.invoiceData.totalAmount || 0,
      paidAmount: this.invoiceData.paidAmount || 0,
      remainingAmount: this.invoiceData.remainingAmount || 0,
      labourAmount: this.invoiceData.labourAmount || 0,
      discountAmount: this.invoiceData.discountAmount || 0,
      roundOffAmount: this.invoiceData.roundOffAmount || 0,
      invoiceDraft: {},
      transferType: ["Cash", ""].includes(this.invoiceData.paymentType) ? "0" : this.invoiceData.transferType,
      transferTypeDialog: false,
      availableBalance: 0,
      firms: [],
      staffs: [],
      // godawns: [],
      banks: [],
      transactionType: this.invoiceData.transactionType || "",
      amountFromCashDisabled: true,
      amountFromBankDisabled: true,
      status: this.invoiceData.status,
      gstType: this.invoiceData.gstType,
      currentUser: {},
      remark: null,
      invoiceId: this.invoiceData.invoiceId || '',
      GST_Val_total: {
        CGST_val: 0,
        SGST_val: 0,
        IGST_val: 0
      },
      GST_Percentage_total: {
        GST_0: 0,
        GST_5: 0,
        GST_12: 0,
        GST_18: 0,
        GST_28: 0
      },
      roundOff: 2,
      printDialog: false,
      transactionDialog: false,
      expansionVal: false,
      transferDetails: {
        accountNumber: this.invoiceData.transferDetails && this.invoiceData.transferDetails.accountNumber || "",
        accountHolderName: this.invoiceData.transferDetails && this.invoiceData.transferDetails.accountHolderName || "",
        bankName: this.invoiceData.transferDetails && this.invoiceData.transferDetails.bankName || "",
        IFSCcode: this.invoiceData.transferDetails && this.invoiceData.transferDetails.IFSCcode || "",
        remark: this.invoiceData.transferDetails && this.invoiceData.transferDetails.remark || ""
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "brandFinYear"]), mapBuyerGetters(["selectedBuyer"]), mapGlobalGetters({
    gState: 'state'
  }), {
    getHeaders: function getHeaders() {
      if (this.gstInvoice) {
        return [{ text: "Name", sortable: false, value: "productName", class: "font-weight-bold primary--text" }, { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" }, { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" }, { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" }, { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" }, { text: "GST value", sortable: false, value: "GSTValue", class: "font-weight-bold primary--text" }, { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "CGST ", sortable: false, value: "CGST", class: "font-weight-bold primary--text" }, { text: "SGST ", sortable: false, value: "SGST", class: "font-weight-bold primary--text" }, { text: "IGST ", sortable: false, value: "IGST", class: "font-weight-bold primary--text" }, { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" }, { text: "", value: "name", sortable: false }];
      } else {
        return [{ text: "Name", sortable: false, value: "productName", class: "font-weight-bold primary--text" }, { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" }, { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" }, { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" }, { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" }, { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" }, { text: "", value: "name", sortable: false }];
      }
    },
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      }).map(function (item) {
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    staffByBrand: function staffByBrand() {
      var _this2 = this;

      return this.staffs.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && item["firm"] === _this2.selectedFirm;
      }).map(function (item) {
        return {
          text: item["staffName"],
          value: item[".key"]
        };
      });
    },

    // godawnByBrand() {
    //   return this.godawns
    //     .filter(item => {
    //       return (
    //         item["brand"] === this.selectedBrand 
    //       );
    //     })
    //     .map(item => {
    //       return {
    //         text: item["godawnName"],
    //         value: item[".key"]
    //       };
    //     });
    // },
    banksByFirms: function banksByFirms() {
      var _this3 = this;

      return this.banks.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && item["firm"] === _this3.selectedFirm;
      }).map(function (item) {
        return {
          text: item["bankName"],
          value: item[".key"]
        };
      });
    },
    totalItems: function totalItems() {
      return this.items.length || 0;
    },
    todaysDate: function todaysDate() {
      var date = new Date();
      return date.getDate() + "\\" + date.getMonth() + "\\" + date.getYear();
    },
    principalValueTotal: function principalValueTotal() {
      var total = this.items.reduce(function (accumulator, currentValue) {
        return accumulator + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(currentValue.totlePrice);
      }, 0);
      // console.log(total)
      var newtotal = Math.round(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(total));
      //  console.log(newtotal)
      this.roundOffAmount = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(newtotal - total).toFixed(this.roundOff);
      return newtotal;
    }
  }),
  mounted: function mounted() {
    this.getCurrentUser();
  },
  updated: function updated() {
    this.expansionVal = true;
  },
  created: function created() {
    this.invoiceDraft = {
      items: this.items,
      amountFromCash: this.amountFromCash || 0,
      amountFromBank: this.amountFromBank || 0,
      buyerId: this.buyerId,
      brand: this.selectedBrand,
      date: Date.now(),
      transferDetails: this.transferDetails,
      transferType: ["Cash", ""].includes(this.paymentType) ? "0" : this.transferType,
      duration: this.alertDuration, // days
      paymentType: this.paymentType,
      transactionType: this.transactionType,
      isCredited: false,
      firm: this.selectedFirm,
      bank: ["Cash", ""].includes(this.paymentType) ? "0" : this.selectedBank,
      totalAmount: this.principalValueTotal || 0,
      paidAmount: this.paidAmount || 0,
      remainingAmount: this.remainingAmount || 0,
      labourAmount: this.labourAmount || 0,
      discountAmount: this.discountAmount || 0,
      roundOffAmount: this.roundOffAmount || 0,
      status: this.status,
      gstType: this.gstType,
      invoiceId: this.invoiceId,
      soldBy: this.soldBy,
      brokerageRate: this.brokerageRate,
      // godawnBy : this.godawnBy,
      placeOfSupply: this.placeOfSupply,
      totalTradeDiscount: this.totalTradeDiscount,
      remark: this.remark
    };
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("staffs", this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand)),
    // this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn),
    this.$bindAsArray("banks", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    // this.$bindAsObject("firmById", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    // this.$bindAsObject("bankById", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoicesOfFirm", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));

    // this.$bindAsArray("brand", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.brand));
  },

  watch: {
    invoiceData: {
      handler: function handler(newVal, oldVal) {
        this.items = newVal.items || [];
        this.totalTradeDiscount = newVal.totalTradeDiscount || 0;
        this.alertDuration = newVal.duration || 0;
        this.paymentType = newVal.paymentType || "";
        this.transferType = ["Cash", ""].includes(this.invoiceData.paymentType) ? "0" : this.invoiceData.transferType, this.amountFromCash = newVal.amountFromCash || 0, this.amountFromBank = newVal.amountFromBank || 0, this.transactionType = newVal.transactionType || "", this.rate = newVal.rate || 2;
        this.invoiceDate = newVal.date ? new Date(newVal.date).toISOString().substr(0, 10) : new Date().toISOString().substr(0, 10);
        this.selectedFirm = newVal.firm || this.selectedFirm || 0;
        this.soldBy = newVal.soldBy || 0;
        // this.brokerageRate = newVal.brokerageRate || 0,
        this.godawnBy = newVal.godawnBy || 0;
        this.placeOfSupply = newVal.placeOfSupply || 0;
        this.selectedBank = newVal.bank || 0;
        this.totalAmount = newVal.totalAmount || 0, this.paidAmount = newVal.paidAmount || 0, this.remainingAmount = newVal.remainingAmount || 0, this.labourAmount = newVal.labourAmount || 0, this.discountAmount = newVal.discountAmount || 0;
        this.status = newVal.status || "", this.gstType = newVal.gstType || "";
        this.remark = newVal.remark;
        //this.invoiceId = newVal.invoiceId || this.invoiceId || "";
      },

      deep: true
    },
    items: {
      handler: function handler(newVal, oldVal) {
        this.updateAndEmit("totalAmount", this.principalValueTotal);
        // this.updateAndEmit('totalCurrentAmount', this.currentValueTotal)
      },

      deep: true
    },
    mode: function mode() {
      this.calculateGSTType();
      this.calculateTotal();
    },
    selectedBrand: function selectedBrand(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("brand", newVal);
      }
    },
    status: function status(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("status", newVal);
      }
    },

    transferDetails: {
      handler: function handler(newVal, oldVal) {
        this.invoiceDraft.transferDetails.accountNumber = newVal.accountNumber;
        this.invoiceDraft.transferDetails.accountHolderName = newVal.accountHolderName;
        this.invoiceDraft.transferDetails.bankName = newVal.bankName;
        this.invoiceDraft.transferDetails.IFSCcode = newVal.IFSCcode;
        this.invoiceDraft.transferDetails.remark = newVal.remark;
      },

      deep: true
    },
    gstType: function gstType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("gstType", newVal);
      }
    },
    placeOfSupply: function placeOfSupply(newVal, oldVal) {
      if (oldVal !== newVal) {
        console.log(newVal);
        this.updateAndEmit("placeOfSupply", newVal);
        this.calculateGSTType();
      }
    },
    soldBy: function soldBy(newVal, oldVal) {
      if (oldVal !== newVal) {
        console.log(newVal);
        this.calculateBrokerage();
        this.updateAndEmit("soldBy", newVal);
      }
    },
    remark: function remark(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("remark", newVal);
      }
    },
    brokerageRate: function brokerageRate(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("brokerageRate", newVal);
      }
    },

    // godawnBy(newVal, oldVal) {
    //   if (oldVal !== newVal) {
    //     this.updateAndEmit("godawnBy", newVal);
    //   }
    // },
    transferType: function transferType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("transferType", newVal);
      }
    },
    buyerId: function buyerId(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("buyerId", newVal);
      }
    },
    alertDuration: function alertDuration(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("duration", __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_int___default()(newVal));
      }
    },
    paymentType: function paymentType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("paymentType", newVal);
        if (this.selectedFirm != "") this.getFirmAndBankBalance();
        this.calculateTotal();
      }
    },
    transactionType: function transactionType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("transactionType", newVal);
        switch (newVal) {
          case "Debit":
            {
              this.updateAndEmit("status", "due");
              break;
            }
          case "Partial Paid":
            {
              this.updateAndEmit("status", "partial");
              if (!this.transactionDialog) this.transactionDialog = true;
              break;
            }
          case "Credit":
            {
              this.updateAndEmit("status", "paid");
              if (!this.transactionDialog) this.transactionDialog = true;
              break;
            }
        }
        this.calculateTotal();
      }
    },
    invoiceDate: function invoiceDate(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("date", new Date(newVal).getTime());
      }
    },
    invoiceId: function invoiceId(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("invoiceId", newVal);
      }
    },
    selectedFirm: function selectedFirm(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("firm", newVal);
        this.getFirmAndBankBalance();
        this.calculateGSTType();
        this.firmBasedInvoiceId();
      }
    },
    selectedBank: function selectedBank(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("bank", newVal);
        if (this.selectedFirm != "") this.getFirmAndBankBalance();
      }
    },
    amountFromCash: function amountFromCash(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.calculateTotal('amountFromCash');
      }
    },
    amountFromBank: function amountFromBank(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.calculateTotal('amountFromBank');
      }
    },
    discountAmount: function discountAmount(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("discountAmount", newVal);
        this.calculateTotal();
      }
    },
    labourAmount: function labourAmount(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("labourAmount", newVal);
        this.calculateTotal();
      }
    },
    roundOffAmount: function roundOffAmount(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("roundOffAmount", newVal);
        //this.calculateTotal();
      }
    }
  },
  methods: {
    firmById: function firmById(id) {
      return this.firms.filter(function (item) {
        return item['.key'] == id;
      })[0];
    },
    buyerById: function buyerById(id) {
      return this.buyers.filter(function (item) {
        return item['.key'] == id;
      })[0];
    },
    sellerById: function sellerById(id) {
      return this.sellers.filter(function (item) {
        return item['.key'] == id;
      })[0];
    },
    bankById: function bankById(id) {
      return this.banks.filter(function (item) {
        return item['.key'] == id;
      })[0];
    },
    calculateBrokerage: function calculateBrokerage() {
      var _this4 = this;

      var staffObj = this.staffs.filter(function (item) {
        return item[".key"] === _this4.soldBy;
      })[0];
      if (staffObj) {
        this.brokerageRate = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(staffObj.brokerageRate);
        console.log(this.brokerageRate);
      }
    },
    formatDate: function formatDate() {
      var tomorrow = new Date(this.dateFormatted);
      tomorrow.setDate(tomorrow.getDate() + 1);
      this.invoiceDate = new Date(tomorrow).toISOString().substr(0, 10);
    },
    basicInvoicePrint: function basicInvoicePrint() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var termsAndConditions, firm, customer;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                termsAndConditions = _this5.getTermsAndConditions();

                _this5.calculateGSTType();
                firm = _this5.firmById(_this5.selectedFirm);

                firm.address = _this5.getAddress(firm);
                customer = _this5.currentUser;

                customer.address = _this5.getAddress(customer);

                if (!_this5.gstInvoice) {
                  _context.next = 11;
                  break;
                }

                _context.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_10__utils_pdfmake__["c" /* convertToBasicInvoice */])({
                  invoiceData: _this5.invoiceDraft,
                  firm: firm,
                  customer: customer,
                  gstTotal: _this5.GST_Val_total,
                  terms: termsAndConditions[0]
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download();
                });

              case 9:
                _context.next = 13;
                break;

              case 11:
                _context.next = 13;
                return Object(__WEBPACK_IMPORTED_MODULE_10__utils_pdfmake__["f" /* convertToBasicInvoiceWithoutGST */])({
                  invoiceData: _this5.invoiceDraft,
                  firm: firm,
                  customer: customer,
                  gstTotal: _this5.GST_Val_total,
                  terms: termsAndConditions[0]
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download();
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    basicInvoicePrint1: function basicInvoicePrint1() {
      var termsAndConditions = this.getTermsAndConditions();
      // if(termsAndConditions.length) {
      //   let banks = [];
      //   termsAndConditions[0].bank.map((bankId) =>{
      //     let bank = this.bankById[bankId]
      //     bank.address = this.getAddress(bank);
      //     banks.push(bank);
      //   })
      //   termsAndConditions[0].bank = banks;
      // } else {
      //   termsAndConditions = [{
      //     termsAndConditions : "",
      //     bank : []
      //   }]
      // }
      this.calculateGSTType();
      var firm = this.firmById(this.selectedFirm);
      firm.address = this.getAddress(firm);
      var customer = this.currentUser;
      customer.address = this.getAddress(customer);

      var doc = this.gstInvoice ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_pdfmake__["c" /* convertToBasicInvoice */])({
        invoiceData: this.invoiceDraft,
        firm: firm,
        customer: customer,
        gstTotal: this.GST_Val_total,
        terms: termsAndConditions[0]
      }) : Object(__WEBPACK_IMPORTED_MODULE_10__utils_pdfmake__["f" /* convertToBasicInvoiceWithoutGST */])({
        invoiceData: this.invoiceDraft,
        firm: firm,
        customer: customer,
        gstTotal: this.GST_Val_total,
        terms: termsAndConditions[0]
      });

      pdfMake.createPdf(doc).download();
    },
    getTermsAndConditions: function getTermsAndConditions() {
      var _this6 = this;

      var termsAndConditions = this.termsAndConditions.filter(function (item) {
        return item["brand"] === _this6.selectedBrand && item['firm'] === _this6.selectedFirm;
      });
      // console.log(termsAndConditions)
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          var banks = [];
          termsAndConditions[0].bank.map(function (bankId) {
            var bank = _this6.bankById(bankId);
            bank.address = _this6.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [{
          termsAndConditions: "",
          banks: []
        }];
      }
      return termsAndConditions;
    },
    getAddress: function getAddress(item) {
      if (!item) {
        return '';
      }
      var address = (item.village ? item.village + " - " : "") + (item.block ? item.block + " - " : "") + (item.tehsil ? item.tehsil + " - " : "") + (item.district ? item.district + " - " : "") + (item.state ? item.state + " - " : "") + (item.country ? item.country + " - " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    print: function print() {
      // let doc = convertToPDFObject(this.items,{
      //   transferType : this.transferType,
      //   amountFromCash : this.amountFromCash,
      //   amountFromBank : this.amountFromBank,
      //   paymentType : this.paymentType,
      //   alertDuration : this.alertDuration,
      //   totalAmount : this.principalValueTotal,
      //   paidAmount : this.paidAmount,
      //   remainingAmount : this.remainingAmount,
      //   discountAmount : this.discountAmount,
      //   labourAmount : this.labourAmount,

      // });
      this.printDialog = true;
      //pdfMake.createPdf(doc).download();
    },
    resetAmounts: function resetAmounts() {
      this.amountFromCash = 0;
      this.amountFromBank = 0;
      this.discountAmount = 0;
      this.labourAmount = 0;
    },
    getFirmAndBankBalance: function getFirmAndBankBalance() {
      var _this7 = this;

      var selectedFirm = this.firms.filter(function (item) {
        return item["brand"] === _this7.selectedBrand && item[".key"] == _this7.selectedFirm;
      });
      this.gstInvoice = selectedFirm[0].GST_user && selectedFirm[0].GST_user == 'Yes' ? true : false;
      var selectedBank = this.selectedBank ? this.banks.filter(function (item) {
        return item["brand"] === _this7.selectedBrand && item[".key"] == _this7.selectedBank;
      }) : null;
      switch (this.paymentType) {

        case "Cash":
          {
            if (this.selectedFirm) {

              this.availableBalance = selectedFirm.length && (selectedFirm[0]["amount"] ? selectedFirm[0]["amount"] : 0);
            } else {
              this.availableBalance = 0;
            }
            break;
          }
        case "Bank Account":
          {
            if (this.selectedBank) {

              this.availableBalance = selectedBank.length && (selectedBank[0]["amount"] ? selectedBank[0]["amount"] : 0);
            } else {
              this.availableBalance = 0;
            }
            break;
          }
        case "CashAndBank Account":
          {
            if (this.selectedFirm && this.selectedBank) {
              this.availableBalance = selectedFirm.length && selectedBank.length && (selectedBank[0]["amount"] ? selectedBank[0]["amount"] : 0) + (selectedFirm[0]["amount"] ? selectedFirm[0]["amount"] : 0);
            } else {
              this.availableBalance = 0;
            }
            break;
          }
      }
    },
    editItem: function editItem(item, fromDialog) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, item);
      this.isEditItems = true;
      if (!fromDialog) {
        this.dialog = true;
      }
    },
    deleteItem: function deleteItem(item) {
      var index = this.items.indexOf(item);
      confirm("Are you sure you want to delete this item?") && this.items.splice(index, 1);
    },
    close: function close(saveAddItem) {
      var _this8 = this;

      if (!saveAddItem) {
        this.dialog = false;
      }
      setTimeout(function () {
        _this8.editedItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this8.defaultItem);
        _this8.editedIndex = -1;
      }, 300);
    },
    calculateTotal: function calculateTotal(type) {
      var discountAmount = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.discountAmount);
      var labourAmount = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.labourAmount);
      var amountFromBank = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.amountFromBank);
      var amountFromCash = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.amountFromCash);
      var totalAmount = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.totalAmount);
      switch (this.paymentType) {
        case 'Cash':
          {
            this.amountFromBank = 0;
            this.amountFromBankDisabled = true;
            switch (this.transactionType) {
              case 'Debit':
                {
                  this.amountFromCashDisabled = true;
                  this.amountFromCash = totalAmount + labourAmount - discountAmount;
                  this.remainingAmount = totalAmount + labourAmount - discountAmount;
                  this.paidAmount = 0;
                  break;
                }
              case 'Partial Paid':
                {
                  this.amountFromCashDisabled = false;
                  this.remainingAmount = totalAmount + labourAmount - (amountFromCash + discountAmount);
                  this.paidAmount = amountFromCash;
                  break;
                }
              case 'Credit':
                {
                  this.amountFromCashDisabled = true;
                  this.amountFromCash = totalAmount + labourAmount - discountAmount;
                  this.remainingAmount = 0;
                  this.paidAmount = totalAmount + labourAmount - discountAmount;
                  break;
                }
            }
            break;
          }
        case 'Bank Account':
          {
            this.amountFromCashDisabled = true;
            this.amountFromCash = 0;
            switch (this.transactionType) {
              case 'Debit':
                {
                  this.amountFromBankDisabled = true;
                  this.amountFromBank = totalAmount + labourAmount - discountAmount;
                  this.remainingAmount = totalAmount + labourAmount - discountAmount;
                  this.paidAmount = 0;
                  break;
                }
              case 'Partial Paid':
                {
                  this.amountFromBankDisabled = false;
                  this.remainingAmount = totalAmount + labourAmount - (amountFromBank + discountAmount);
                  this.paidAmount = amountFromBank;
                  break;
                }
              case 'Credit':
                {
                  this.amountFromBankDisabled = true;
                  this.amountFromBank = totalAmount + labourAmount - discountAmount;
                  this.remainingAmount = 0;
                  this.paidAmount = totalAmount + labourAmount - discountAmount;
                  break;
                }
            }
            break;
          }
        case 'CashAndBank Account':
          {
            this.amountFromCashDisabled = false;
            this.amountFromBankDisabled = false;
            var totalBankAndCash = amountFromCash + amountFromBank;
            switch (this.transactionType) {
              case 'Debit':
                {
                  this.remainingAmount = totalAmount + labourAmount - discountAmount;
                  this.paidAmount = 0;
                  break;
                }
              case 'Partial Paid':
                {
                  this.paidAmount = totalBankAndCash;
                  this.remainingAmount = totalAmount + labourAmount - (paidAmount + discountAmount);
                  break;
                }
              case 'Credit':
                {
                  this.remainingAmount = 0;
                  this.paidAmount = totalAmount + labourAmount - discountAmount;
                  break;
                }
            }
            break;
          }
        case '':
          {
            this.amountFromCashDisabled = true;
            this.amountFromBankDisabled = true;
            this.amountFromCash = 0;
            this.amountFromBank = 0;
            this.paidAmount = 0;
            this.remainingAmount = totalAmount + labourAmount - discountAmount;
            break;
          }
      }
      this.paidAmount = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.paidAmount).toFixed(parseInt(this.roundOff));
      if (type != 'amountFromCash') this.amountFromCash = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.amountFromCash).toFixed(parseInt(this.roundOff));
      if (type != 'amountFromBank') this.amountFromBank = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.amountFromBank).toFixed(parseInt(this.roundOff));
      this.remainingAmount = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.remainingAmount).toFixed(parseInt(this.roundOff));
      this.updateAndEmit('paidAmount', this.paidAmount);
      this.updateAndEmit('amountFromCash', this.amountFromCash);
      this.updateAndEmit('amountFromBank', this.amountFromBank);
      this.updateAndEmit('remainingAmount', this.remainingAmount);
    },
    save: function save(editedItem, saveAndAdd) {
      var _this9 = this;

      if (this.editedIndex > -1) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.items[this.editedIndex], editedItem);
      } else {
        this.items.push(editedItem);
      }
      this.calculateGSTType();
      setTimeout(function () {
        _this9.editedItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this9.defaultItem);
        _this9.editedIndex = -1;
        _this9.isEditItems = false;
      }, 300);
      this.close(saveAndAdd);
    },
    calculateGSTType: function calculateGSTType() {
      var _this10 = this;

      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.currentUser).length === 0) {
        this.getCurrentUser();
      }
      this.GST_Val_total.SGST_val = 0;
      this.GST_Val_total.CGST_val = 0;
      this.GST_Val_total.IGST_val = 0;
      this.items.map(function (item, index) {
        var GST = item["taxableGST_rate"];
        var firm = _this10.firmById(_this10.selectedFirm);
        if (_this10.selectedFirm && _this10.currentUser.state && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(GST) && firm.state === _this10.placeOfSupply) {
          item["CGST_val"] = item["GSTValue"] / 2;
          item["CGST"] = GST / 2;
          item["SGST_val"] = item["GSTValue"] / 2;
          item["SGST"] = GST / 2;
          item["IGST"] = 0;
          item["IGST_val"] = 0;
          _this10.GST_Val_total.SGST_val += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item["SGST_val"]);
          _this10.GST_Val_total.CGST_val += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item["CGST_val"]);
          _this10.GST_Val_total.IGST_val += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item["IGST_val"]);
          _this10.updateAndEmit("gstType", "SGST|CGST");
        } else {
          item["IGST"] = GST;
          item["CGST"] = 0;
          item["SGST"] = 0;
          item["IGST_val"] = item["GSTValue"];
          item["CGST_val"] = 0;
          item["SGST_val"] = 0;
          _this10.GST_Val_total.SGST_val += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item["SGST_val"]);
          _this10.GST_Val_total.CGST_val += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item["CGST_val"]);
          _this10.GST_Val_total.IGST_val += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item["IGST_val"]);
          _this10.updateAndEmit("gstType", "IGST");
          _this10.totalTradeDiscount += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item["tradeDiscount"]);
        }
        _this10.items[index] = item;
      });
      this.GST_Percentage_total = Object(__WEBPACK_IMPORTED_MODULE_11__utils___["c" /* getGSTPercentageTotal */])(this.items);
      this.updateAndEmit("items", this.items);
      this.updateAndEmit("tradeDiscount", this.totalTradeDiscount);
    },
    updateAndEmit: function updateAndEmit(key, value) {
      this.invoiceDraft[key] = value;
      this.$emit("setInvoiceData", this.invoiceDraft);
    },
    saveAndPrint: function saveAndPrint() {
      this.basicInvoicePrint();
      this.saveInvoice();
    },
    saveInvoice: function saveInvoice() {
      this.updateAndEmit("buyerId", this.selectedBuyer);
      this.$emit("close");
    },
    getCurrentUser: function getCurrentUser() {
      var _this11 = this;

      var buyer = this.buyerById(this.selectedBuyer);
      var seller = this.sellerById(this.selectedBuyer);
      this.isUserBuyer = buyer ? true : false;
      // this.currentUser =
      //   buyer && buyer.state ? buyer : seller && seller.state ? seller : {};
      // this.placeOfSupply = this.currentUser.state;
      this.currentUser = buyer ? buyer : seller;
      if (this.currentUser.state) {
        this.placeOfSupply = this.currentUser.state;
      }
      if (this.currentUser.defaultFirm) {
        // console.log(this.currentUser.defaultFirm)
        this.selectedFirm = this.currentUser.defaultFirm;
      } else {
        var defaultFirm = this.firms.filter(function (item) {
          return item["brand"] === _this11.selectedBrand && !!item['defaultFirm'];
        })[0];
        this.selectedFirm = defaultFirm['.key'];
        // this.selectedFirm = this.firmsByBrand[0].value;
        // console.log(this.selectedFirm)
      }
      this.getFirmAndBankBalance();
      if (!this.invoiceId) {
        this.firmBasedInvoiceId();
      }
    },
    firmBasedInvoiceId: function firmBasedInvoiceId() {
      var _this12 = this;

      if (this.isUserBuyer) {
        var firmInvoiceCount = this.invoicesOfFirm.filter(function (item) {
          return item["brand"] === _this12.selectedBrand && item["firm"] == _this12.selectedFirm && item["isBuyer"] == true;
        }).length;
        var finYear = new Date().getFullYear() + '-' + (new Date().getFullYear() + 1) % 100 + '-SF-';
        this.invoiceId = finYear + (firmInvoiceCount + 1);
        console.log(this.invoiceId);
      }
    },
    duplicateCheckInvoiceId: function duplicateCheckInvoiceId() {
      var _this13 = this;

      var invoices = this.invoicesOfFirm.filter(function (item) {
        return item["brand"] === _this13.selectedBrand && item["firm"] == _this13.selectedFirm && item["invoiceId"] == _this13.invoiceId;
      });

      if (invoices.length) {
        this.duplicateError = 'Invoice with invoiceId ' + this.invoiceId + ' Already exist.';
        setTimeout(function () {
          _this13.duplicateError = null;
        }, 3000);
      }
    }
  }
});

/***/ }),

/***/ 1754:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_body_parser__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_body_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_body_parser__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        buyerId: String,
        isEditItems: Boolean,
        gstInvoice: Boolean,
        allItems: Array,
        editedItem: {
            type: Object,
            default: function _default() {
                return {
                    productName: "",
                    productId: "",
                    HSN_code: "",
                    taxableGST_rate: 0,
                    rate: 0,
                    unit: "",
                    quantity: 0,
                    basicPrice: 0,
                    GSTValue: 0,
                    totlePrice: 0,
                    GST_type: "",
                    productUnit: '',
                    tradeDiscount: 0,
                    expiryDate: new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10),
                    manufacturingDate: new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10),
                    batchNumber: 'DEFAULT'
                };
            }
        }
    },
    data: function data() {
        return {
            headers: [{ text: "Name", sortable: false, value: "productName", class: "font-weight-bold primary--text" }, { text: "HSN code", sortable: false, value: "HSN_code", class: "font-weight-bold primary--text" }, { text: "GST", sortable: false, value: "taxableGST_rate", class: "font-weight-bold primary--text" }, { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" }, { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" }, { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" }, { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" }, { text: "GST value", sortable: false, value: "GSTValue", class: "font-weight-bold primary--text" }, { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "CGST value ( %)", sortable: false, value: "CGST", class: "font-weight-bold primary--text" }, { text: "SGST value ( %)", sortable: false, value: "SGST", class: "font-weight-bold primary--text" }, { text: "IGST value ( %)", sortable: false, value: "IGST", class: "font-weight-bold primary--text" }, { text: "", value: "name", sortable: false }],
            isBuyer: null,
            isTradePercentage: false,
            scannerDialog: false,
            tradeDiscountPercentage: null,
            item: this.editedItem,
            products: [],
            selectedProduct: {},
            stepper: 1,
            isOpeningBalance: false,
            isStanderedPrice: false,
            addProductDialog: false,
            datepicker: false,
            snackbar: false,
            productChanged: false,
            duplicateError: null,
            timeout: 3000,
            datepickerExp: null,
            datepickerMen: null,
            GST_types: [{
                text: "Exempt",
                value: "EXEMPT"
            }, {
                text: "Nil Rated",
                value: "NILL"
            }, {
                text: "Taxable",
                value: "TAXABLE"
            }, {
                text: "Non-GST",
                value: "OTHER"
            }],
            currentProduct: {
                name: "",
                description: "",
                HSN_code: 0,
                GST_type: "",
                taxableGST_rate: 0,
                unit: "",
                quantity: 0,
                brand: "",
                openingDate: new Date().toISOString().substr(0, 10),
                purchasingPrice: null,
                sellingPrice: null,
                openingBalance: null,
                gstValue: 0,
                basicPrice: 0
            }
        };
    },

    watch: {
        editedItem: function editedItem(val) {
            this.item = this.editedItem;
            console.log(this.item);
        },

        "item.rate": {
            handler: function handler(newVal, oldVal) {
                this.calculatePrices();
            },

            deep: true
        },
        "item.tradeDiscount": {
            handler: function handler(newVal, oldVal) {
                this.calculatePrices();
            },

            deep: true
        },
        "item.quantity": {
            handler: function handler(newVal, oldVal) {
                this.calculatePrices();
            },

            deep: true
        },
        "item.unit": {
            handler: function handler(newVal, oldVal) {
                // this.productChange(this.selectedProduct);
            },

            deep: true
        },
        "currentProduct.GST_type": {
            handler: function handler(newVal, oldVal) {
                if (newVal != "TAXABLE") {
                    this.currentProduct.taxableGST_rate = 0;
                }
            },

            deep: true
        },
        "currentProduct.basicPrice": {
            handler: function handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.calculateOpeningBalance();
                }
            },

            deep: true
        },
        "currentProduct.gstValue": {
            handler: function handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.calculateOpeningBalance();
                }
            },

            deep: true
        }
    },
    created: function created() {
        this.$bindAsArray("rate", this.$root.$firebaseRefs.rate.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('buyerById', this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsArray("batch", this.$root.$firebaseRefs.batchTransaction.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand));
    },

    computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), mapGlobalGetters({ units: "productUnit" }), {
        productsByBrand: function productsByBrand() {
            var _this = this;

            if (this.rate) {
                return this.products.filter(function (item) {
                    return item["brand"] === _this.selectedBrand && (!_this.gstInvoice ? item.GST_type != 'TAXABLE' : true) && (item.openingDate ? item.openingDate >= _this.finYear.start && item.openingDate <= _this.finYear.end : true);
                });
            }
        },
        godawnByBrand: function godawnByBrand() {
            var _this2 = this;

            return this.godawns.filter(function (item) {
                return item["brand"] === _this2.selectedBrand;
            }).map(function (item) {
                return {
                    text: item["godawnName"],
                    value: item[".key"]
                };
            });
        },
        getHeaders: function getHeaders() {
            if (this.gstInvoice) {
                return [{ text: "Name", sortable: false, value: "productName", class: "font-weight-bold primary--text" }, { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" }, { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" }, { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" }, { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" }, { text: "GST value", sortable: false, value: "GSTValue", class: "font-weight-bold primary--text" }, { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "CGST ", sortable: false, value: "CGST", class: "font-weight-bold primary--text" }, { text: "SGST ", sortable: false, value: "SGST", class: "font-weight-bold primary--text" }, { text: "IGST ", sortable: false, value: "IGST", class: "font-weight-bold primary--text" }, { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" }, { text: "", value: "name", sortable: false }];
            } else {
                return [{ text: "Name", sortable: false, value: "productName", class: "font-weight-bold primary--text" }, { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" }, { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" }, { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" }, { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" }, { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" }, { text: "", value: "name", sortable: false }];
            }
        },
        formTitle: function formTitle() {
            return this.editedIndex === -1 ? "Edit Item" : "New Item";
        }
    }),

    methods: {
        close: function close() {
            this.$emit("closeAddItem", false);
            this.reset();
        },
        editItem: function editItem(item) {
            this.reset();
            this.$emit("editItem", item, true);
        },
        deleteItem: function deleteItem(item) {
            this.reset();
            this.$emit("deleteItem", item);
        },
        productChange: function productChange(val) {
            this.selectedProduct = val;
            var buyer = this.buyerById[this.buyerId];
            var isBuyer = buyer ? true : false;
            this.item.productId = val[".key"];
            this.item.HSN_code = val["HSN_code"];
            this.item.taxableGST_rate = val["taxableGST_rate"];
            this.item.unit = val["unit"];

            // console.log(JSON.stringify(this.selectedProduct.unit))
            // console.log(JSON.stringify(this.item.unit))
            if (this.selectedProduct.unit == this.item.unit) {
                this.item.rate = isBuyer ? val["sellingPrice"] : val["purchasingPrice"];
                // console.log(val["purchasingPrice"])
                // console.log( val["sellingPrice"])
            }
            if (isBuyer) {
                this.getProductBatch();
            }
            this.productChanged = true;
        },
        calculateTradeDiscount: function calculateTradeDiscount() {
            this.item.tradeDiscount = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.tradeDiscountPercentage * this.item.rate * this.item.quantity / 100).toFixed(2);
        },
        calculatePrices: function calculatePrices() {
            if (this.isBuyer == null) {
                var buyer = this.buyerById[this.buyerId];
                this.isBuyer = buyer ? true : false;
            }
            this.item.basicPrice = (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.rate * this.item.quantity) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.tradeDiscount)).toFixed(2);
            this.item.GSTValue = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice * (parseFloat(this.item.taxableGST_rate) / 100)).toFixed(2);
            this.item.totlePrice = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.GSTValue)).toFixed(2);
        },
        getProductBatch: function getProductBatch() {
            var _this3 = this;

            var batchArray = this.batch.filter(function (item) {
                return item['brand'] === _this3.selectedBrand && item['product'] === _this3.selectedProduct['.key'];
            });
            batchArray.sort(function (a, b) {
                return -(new Date(b.expiryDate) - new Date(a.expiryDate));
            });
            console.log(batchArray);
            if (batchArray.length) {
                this.item.batchNumber = batchArray[0].batchNumber;
                // this.item.expiryDate = new Date(batchArray[0].expiryDate).toISOString().substr(0, 10);
                // this.item.manufacturingDate = new Date(batchArray[0].manufacturingDate).toISOString().substr(0, 10);
                this.item.expiryDate = batchArray[0].expiryDate ? new Date(batchArray[0].expiryDate).toISOString().substr(0, 10) : new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10);
                this.item.manufacturingDate = batchArray[0].manufacturingDate ? new Date(batchArray[0].manufacturingDate).toISOString().substr(0, 10) : new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10);
            } else {
                this.item.expiryDate = new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10);
                this.item.manufacturingDate = new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10);
                this.item.batchNumber = 'DEFAULT';
            }
        },
        save: function save(saveAndAdd) {
            var buyer = this.buyerById[this.buyerId];
            var isBuyer = buyer ? true : false;
            // if(!this.isBuyer) {
            //   this.item.expiryDate = new Date(this.item.expiryDate).getTime(),
            //   this.item.manufacturingDate = new Date(this.item.manufacturingDate).getTime()
            // }
            if (this.item.quantity > this.selectedProduct.quantity && isBuyer) {
                if (confirm("stock can go in negative - do you want to proceed ?")) {
                    if (!this.isEditItems || this.isEditItems && this.productChanged) {
                        this.item.productName = this.selectedProduct.name;
                        this.item.GST_type = this.selectedProduct.GST_type;
                        this.item.productUnit = this.selectedProduct.unit;
                        this.item.availableQuantity = this.selectedProduct.quantity;
                    }
                    this.$emit('saveAddItem', this.item, saveAndAdd);
                    this.reset();
                }
            } else {
                if (!this.isEditItems || this.isEditItems && this.productChanged) {
                    this.item.productName = this.selectedProduct.name;
                    this.item.GST_type = this.selectedProduct.GST_type;
                    this.item.productUnit = this.selectedProduct.unit;
                    this.item.availableQuantity = this.selectedProduct.quantity;
                }
                this.$emit('saveAddItem', this.item, saveAndAdd);
                this.reset();
            }
        },
        reset: function reset() {
            this.item = {
                productName: "",
                productId: "",
                HSN_code: "",
                taxableGST_rate: 0,
                rate: 0,
                unit: "",
                quantity: 0,
                basicPrice: 0,
                GSTValue: 0,
                GST_type: "",
                productUnit: '',
                totlePrice: 0,
                tradeDiscount: 0
            };
            this.productChanged = false;
            this.tradeDiscountPercentage = null;
            this.isTradePercentage = false;
        },
        duplicateCheck: function duplicateCheck() {
            var _this4 = this;

            var duplicateCheck = this.products.filter(function (item) {
                return item["brand"] === _this4.selectedBrand && item['name'] == _this4.currentProduct.name;
            });
            if (duplicateCheck.length) {
                this.duplicateError = 'Product with name ' + this.currentProduct.name + ' Already exist.';
                setTimeout(function () {
                    _this4.duplicateError = null;
                }, 3000);
            }
        },
        saveProduct: function saveProduct() {
            var _this5 = this;

            var duplicateCheck = this.products.filter(function (item) {
                return item["brand"] === _this5.selectedBrand && item['name'] == _this5.currentProduct.name;
            });
            // console.log(duplicateCheck)
            if (duplicateCheck.length) {
                this.duplicateError = 'Product with name ' + this.currentProduct.name + ' Already exist.';
                setTimeout(function () {
                    _this5.duplicateError = null;
                }, 3000);
            } else {
                this.currentProduct["brand"] = this.selectedBrand;
                this.currentProduct["HSN_code"] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProduct.HSN_code);
                this.currentProduct["taxableGST_rate"] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProduct.taxableGST_rate);
                this.currentProduct.purchaseQuantity = 0;
                this.currentProduct.saleQuantity = 0;
                this.currentProduct.openingQuantity = this.currentProduct.quantity;
                this.currentProduct.openingDate = new Date(this.currentProduct.openingDate).getTime();
                this.$root.$firebaseRefs.products.push(this.currentProduct);
                this.addProductDialog = false;
                this.snackbar = true;
            }
        },
        addProduct: function addProduct() {
            this.stepper = 1;
            this.currentProduct = {
                name: "",
                description: "",
                HSN_code: 0,
                GST_type: "",
                taxableGST_rate: 0,
                unit: "",
                quantity: 0,
                openingDate: new Date().toISOString().substr(0, 10),
                brand: "",
                basicPrice: 0,
                gstValue: 0,
                purchasingPrice: null,
                sellingPrice: null,
                openingBalance: null,
                purchasingPricePerProduct: null
            };
            this.addProductDialog = true;
        },
        calculateOpeningBalance: function calculateOpeningBalance() {
            this.currentProduct.openingBalance = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProduct.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProduct.gstValue);
        },
        scanItem: function scanItem() {
            this.scannerDialog = true;
            this.initQugga();
        },
        initQugga: function initQugga() {
            var selfVue = this;
            $(function () {
                var resultCollector = Quagga.ResultCollector.create({
                    capture: true,
                    capacity: 20,
                    blacklist: [{
                        code: "WIWV8ETQZ1", format: "code_93"
                    }, {
                        code: "EH3C-%GU23RK3", format: "code_93"
                    }, {
                        code: "O308SIHQOXN5SA/PJ", format: "code_93"
                    }, {
                        code: "DG7Q$TV8JQ/EN", format: "code_93"
                    }, {
                        code: "VOFD1DB5A.1F6QU", format: "code_93"
                    }, {
                        code: "4SO64P4X8 U4YUU1T-", format: "code_93"
                    }],
                    filter: function filter(codeResult) {
                        // only store results which match this constraint
                        // e.g.: codeResult
                        return true;
                    }
                });
                var App = {
                    init: function init() {
                        var self = this;

                        Quagga.init(this.state, function (err) {
                            if (err) {
                                return self.handleError(err);
                            }
                            //Quagga.registerResultCollector(resultCollector);
                            App.attachListeners();
                            App.checkCapabilities();
                            Quagga.start();
                        });
                    },
                    handleError: function handleError(err) {
                        console.log(err);
                    },
                    checkCapabilities: function checkCapabilities() {
                        var track = Quagga.CameraAccess.getActiveTrack();
                        var capabilities = {};
                        if (typeof track.getCapabilities === 'function') {
                            capabilities = track.getCapabilities();
                        }
                        this.applySettingsVisibility('zoom', capabilities.zoom);
                        this.applySettingsVisibility('torch', capabilities.torch);
                    },
                    updateOptionsForMediaRange: function updateOptionsForMediaRange(node, range) {
                        console.log('updateOptionsForMediaRange', node, range);
                        var NUM_STEPS = 6;
                        var stepSize = (range.max - range.min) / NUM_STEPS;
                        var option;
                        var value;
                        while (node.firstChild) {
                            node.removeChild(node.firstChild);
                        }
                        for (var i = 0; i <= NUM_STEPS; i++) {
                            value = range.min + stepSize * i;
                            option = document.createElement('option');
                            option.value = value;
                            option.innerHTML = value;
                            node.appendChild(option);
                        }
                    },
                    applySettingsVisibility: function applySettingsVisibility(setting, capability) {
                        // depending on type of capability
                        if (typeof capability === 'boolean') {
                            var node = document.querySelector('input[name="settings_' + setting + '"]');
                            if (node) {
                                node.parentNode.style.display = capability ? 'block' : 'none';
                            }
                            return;
                        }
                        if (window.MediaSettingsRange && capability instanceof window.MediaSettingsRange) {
                            var node = document.querySelector('select[name="settings_' + setting + '"]');
                            if (node) {
                                this.updateOptionsForMediaRange(node, capability);
                                node.parentNode.style.display = 'block';
                            }
                            return;
                        }
                    },
                    initCameraSelection: function initCameraSelection() {
                        var streamLabel = Quagga.CameraAccess.getActiveStreamLabel();

                        return Quagga.CameraAccess.enumerateVideoDevices().then(function (devices) {
                            function pruneText(text) {
                                return text.length > 30 ? text.substr(0, 30) : text;
                            }
                            var $deviceSelection = document.getElementById("deviceSelection");
                            while ($deviceSelection.firstChild) {
                                $deviceSelection.removeChild($deviceSelection.firstChild);
                            }
                            devices.forEach(function (device) {
                                var $option = document.createElement("option");
                                $option.value = device.deviceId || device.id;
                                $option.appendChild(document.createTextNode(pruneText(device.label || device.deviceId || device.id)));
                                $option.selected = streamLabel === device.label;
                                $deviceSelection.appendChild($option);
                            });
                        });
                    },
                    attachListeners: function attachListeners() {
                        var self = this;

                        self.initCameraSelection();
                        $(".controls").on("click", "button.stop", function (e) {
                            e.preventDefault();
                            Quagga.stop();
                            self._printCollectedResults();
                        });

                        $(".controls .reader-config-group").on("change", "input, select", function (e) {
                            e.preventDefault();
                            var $target = $(e.target),
                                value = $target.attr("type") === "checkbox" ? $target.prop("checked") : $target.val(),
                                name = $target.attr("name"),
                                state = self._convertNameToState(name);

                            console.log("Value of " + state + " changed to " + value);
                            self.setState(state, value);
                        });
                    },
                    _printCollectedResults: function _printCollectedResults() {
                        var results = resultCollector.getResults(),
                            $ul = $("#result_strip ul.collector");

                        results.forEach(function (result) {
                            var $li = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');

                            $li.find("img").attr("src", result.frame);
                            $li.find("h4.code").html(result.codeResult.code + " (" + result.codeResult.format + ")");
                            $ul.prepend($li);
                        });
                    },
                    _accessByPath: function _accessByPath(obj, path, val) {
                        var parts = path.split('.'),
                            depth = parts.length,
                            setter = typeof val !== "undefined" ? true : false;

                        return parts.reduce(function (o, key, i) {
                            if (setter && i + 1 === depth) {
                                if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(o[key]) === "object" && (typeof val === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(val)) === "object") {
                                    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(o[key], val);
                                } else {
                                    o[key] = val;
                                }
                            }
                            return key in o ? o[key] : {};
                        }, obj);
                    },
                    _convertNameToState: function _convertNameToState(name) {
                        return name.replace("_", ".").split("-").reduce(function (result, value) {
                            return result + value.charAt(0).toUpperCase() + value.substring(1);
                        });
                    },
                    detachListeners: function detachListeners() {
                        $(".controls").off("click", "button.stop");
                        $(".controls .reader-config-group").off("change", "input, select");
                    },
                    applySetting: function applySetting(setting, value) {
                        var track = Quagga.CameraAccess.getActiveTrack();
                        if (track && typeof track.getCapabilities === 'function') {
                            switch (setting) {
                                case 'zoom':
                                    return track.applyConstraints({ advanced: [{ zoom: parseFloat(value) }] });
                                case 'torch':
                                    return track.applyConstraints({ advanced: [{ torch: !!value }] });
                            }
                        }
                    },
                    setState: function setState(path, value) {
                        var self = this;

                        if (typeof self._accessByPath(self.inputMapper, path) === "function") {
                            value = self._accessByPath(self.inputMapper, path)(value);
                        }

                        if (path.startsWith('settings.')) {
                            var setting = path.substring(9);
                            return self.applySetting(setting, value);
                        }
                        self._accessByPath(self.state, path, value);

                        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.state));
                        App.detachListeners();
                        Quagga.stop();
                        App.init();
                    },
                    inputMapper: {
                        inputStream: {
                            constraints: function constraints(value) {
                                if (/^(\d+)x(\d+)$/.test(value)) {
                                    var values = value.split('x');
                                    return {
                                        width: { min: parseInt(values[0]) },
                                        height: { min: parseInt(values[1]) }
                                    };
                                }
                                return {
                                    deviceId: value
                                };
                            }
                        },
                        numOfWorkers: function numOfWorkers(value) {
                            return parseInt(value);
                        },
                        decoder: {
                            readers: function readers(value) {
                                if (value === 'ean_extended') {
                                    return [{
                                        format: "ean_reader",
                                        config: {
                                            supplements: ['ean_5_reader', 'ean_2_reader']
                                        }
                                    }];
                                }
                                return [{
                                    format: value + "_reader",
                                    config: {}
                                }];
                            }
                        }
                    },
                    state: {
                        inputStream: {
                            type: "LiveStream",
                            constraints: {
                                width: { min: 640 },
                                height: { min: 480 },
                                facingMode: "environment",
                                aspectRatio: { min: 1, max: 2 }
                            }
                        },
                        locator: {
                            patchSize: "medium",
                            halfSample: true
                        },
                        numOfWorkers: 2,
                        frequency: 10,
                        decoder: {
                            readers: [{
                                format: "ean_reader",
                                config: {}
                            }]
                        },
                        locate: true
                    },
                    lastResult: null
                };

                App.init();

                Quagga.onProcessed(function (result) {
                    var drawingCtx = Quagga.canvas.ctx.overlay,
                        drawingCanvas = Quagga.canvas.dom.overlay;

                    if (result) {
                        if (result.boxes) {
                            drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
                            result.boxes.filter(function (box) {
                                return box !== result.box;
                            }).forEach(function (box) {
                                Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, { color: "green", lineWidth: 2 });
                            });
                        }

                        if (result.box) {
                            Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, { color: "#00F", lineWidth: 2 });
                        }

                        if (result.codeResult && result.codeResult.code) {
                            Quagga.ImageDebug.drawPath(result.line, { x: 'x', y: 'y' }, drawingCtx, { color: 'red', lineWidth: 3 });
                        }
                    }
                });

                Quagga.onDetected(function (result) {
                    var code = result.codeResult.code;
                    console.log(code);
                    Quagga.stop();
                    selfVue.addProductByBarcode(code);
                    // if (App.lastResult !== code) {
                    //     App.lastResult = code;
                    //     var $node = null, canvas = Quagga.canvas.dom.image;

                    //     $node = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');
                    //     $node.find("img").attr("src", canvas.toDataURL());
                    //     $node.find("h4.code").html(code);
                    //     $("#result_strip ul.thumbnails").prepend($node);
                    // }
                });
            });
        },
        addProductByBarcode: function addProductByBarcode(barcode) {
            var product = this.productsByBrand.filter(function (item) {
                return item.barcode == barcode;
            })[0];
            this.productChange(product);
            this.item.productName = product.name;
            this.scannerDialog = false;
        }
    }
});

/***/ }),

/***/ 1755:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_pdfmake__ = __webpack_require__(31);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: ["invoiceData", "bank", "firm", "seller", "buyer", "termsAndConditions", "gstTotal"],
  data: function data() {
    return {
      isBuyer: null,
      customer: null,
      Itemheaders: [{ text: "Product Name", sortable: false, value: "productName" }, { text: "HSN code", sortable: false, value: "HSN_code" }, { text: "GST", sortable: false, value: "taxableGST_rate" }, { text: "Rate", sortable: false, value: "rate" }, { text: "Unit", sortable: false, value: "unit" }, { text: "Quantity", sortable: false, value: "quantity" }, { text: "Basic Price", sortable: false, value: "basicPrice" }, { text: "GST value", sortable: false, value: "GSTValue" }, { text: "Total Price", sortable: false, value: "totlePrice" }, { text: "CGST value ( %)", sortable: false, value: "CGST" }, { text: "SGST value ( %)", sortable: false, value: "SGST" }, { text: "IGST value ( %)", sortable: false, value: "IGST" }],
      transportationDetails: {
        vehicleNo: null,
        driverName: null,
        driverNumber: null,
        supplyDate: null
      },
      mobile: {
        value: "",
        rules: [function (v) {
          return (/^$/.test(v) || /^(\+91|\+91\-|0)?[789]\d{9}$/.test(v) || "Mobile number is wrong"
          );
        }]
      },
      consignee: null,
      datepicker: false,
      datepickerBillDate: false,
      datepickerValidFrom: false,
      datepickerValidUntil: false,
      datepickerDocumentDate: false,
      datepickerDepartureDate: false,
      tab: null,
      ebillDetails: {
        billNo: null,
        billDate: null,
        generatedBy: null,
        validFrom: null,
        validUntil: null,
        GSTofSupplier: null,
        GSTofReceipient: null,
        placeOfDispatch: null, //add
        placeOfDelivery: null, //add
        documentNo: null,
        documentDate: null,
        valueOfGoods: null,
        reasonOfTransportation: null,
        transportationDetails: {
          mode: null,
          vehicleNo: null,
          from: null, //ad
          to: null, // add
          departureDate: null,
          enteredBy: null,
          CEWBno: null,
          remark: null
        }
      },
      address: {
        village: null,
        block: null,
        tehsil: null,
        district: null,
        state: null,
        field1: null,
        field2: null,
        fullAddress: null
      },
      addressDialog: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters({
    gVillage: "village",
    gBlock: "block",
    gTehsil: "tehsil",
    gDistrict: "district",
    gState: "state",
    gCountry: "country"
  })),
  methods: {
    getAddress: function getAddress(item) {
      var address = (item.village ? item.village + " - " : "") + (item.block ? item.block + " - " : "") + (item.tehsil ? item.tehsil + " - " : "") + (item.district ? item.district + " - " : "") + (item.state ? item.state + " - " : "") + (item.country ? item.country + " - " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    setAddress: function setAddress() {
      if (this.address.field1 && this.address.field2) {
        this.ebillDetails[this.address.field1][this.address.field2] = this.address.fullAddress;
      } else if (this.address.field1) {
        this.ebillDetails[this.address.field1] = this.address.fullAddress;
      }
      this.addressDialog = false;
    },
    resetAddress: function resetAddress() {
      this.address = {
        village: null,
        block: null,
        tehsil: null,
        district: null,
        state: null,
        field1: null,
        field2: null,
        fullAddress: null
      };
    },
    checkUser: function checkUser() {
      if (this.buyer && "name" in this.buyer) {
        this.isBuyer = false;
        this.customer = this.buyer;
        this.customer.address = this.getAddress(this.buyer);
        this.consignee = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.customer));
      } else if (this.seller && "name" in this.seller) {
        this.isBuyer = true;
        this.customer = this.$listenersseller;
        this.customer.address = this.getAddress(this.seller);
        this.consignee = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.customer));
      }
      this.getEbillDetails();
    },
    addressDialogOpen: function addressDialogOpen(field1, field2) {
      this.address.field1 = field1;
      this.address.field2 = field2;
      this.addressDialog = true;
    },
    getEbillDetails: function getEbillDetails() {
      this.ebillDetails.generatedBy = this.firm && this.firm.name + " - " + this.firm.GST_number;
      this.ebillDetails.validFrom = this.invoiceData && this.invoiceData.date;
      this.ebillDetails.GSTofSupplier = this.firm && this.firm.GST_number;
      this.ebillDetails.GSTofReceipient = this.customer && this.customer.GST_number;
      this.ebillDetails.valueOfGoods = this.invoiceData && this.invoiceData.totalAmount;
      this.ebillDetails.transportationDetails.enteredBy = this.firm && this.firm.GST_number;
    },
    printInvoice: function printInvoice() {
      var doc = Object(__WEBPACK_IMPORTED_MODULE_3__utils_pdfmake__["k" /* convertToEwayBillType2 */])({
        invoiceData: this.invoiceData,
        bank: this.bank,
        firm: this.firm,
        customer: this.customer,
        ebillDetails: this.ebillDetails,
        consignee: this.consignee,
        transportationDetails: this.transportationDetails,
        terms: this.termsAndConditions[0],
        gstTotal: this.gstTotal
      });
      // console.log(doc)
      this.printDialog = true;
      pdfMake.createPdf(doc).download();
    }
  },
  watch: {
    seller: function seller(newVal, oldVal) {
      if (newVal) {
        this.checkUser();
      }
    },
    buyer: function buyer(newVal, oldVal) {
      if (newVal) {
        this.checkUser();
      }
    },
    firm: function firm(newVal, oldVal) {
      if (newVal) {
        this.firm.address = this.getAddress(this.firm);
      }
    },

    "address.village": function addressVillage(newVal, oldVal) {
      this.address.fullAddress = this.getAddress(this.address);
    },
    "address.block": function addressBlock(newVal, oldVal) {
      this.address.fullAddress = this.getAddress(this.address);
    },
    "address.tehsil": function addressTehsil(newVal, oldVal) {
      this.address.fullAddress = this.getAddress(this.address);
    },
    "address.district": function addressDistrict(newVal, oldVal) {
      this.address.fullAddress = this.getAddress(this.address);
    },
    "address.state": function addressState(newVal, oldVal) {
      this.address.fullAddress = this.getAddress(this.address);
    },
    "invoiceData.totalAmount": {
      handler: function handler(newVal, oldVal) {
        this.getEbillDetails();
      },

      deep: true
    },
    "invoiceData.firm": {
      handler: function handler(newVal, oldVal) {
        this.getEbillDetails();
      },

      deep: true
    }
  },
  created: function created() {
    this.checkUser();
  }
});

/***/ }),

/***/ 1756:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceScreen_vue__ = __webpack_require__(1753);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a121959_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceScreen_vue__ = __webpack_require__(1763);
function injectStyle (ssrContext) {
  __webpack_require__(1757)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a121959_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1757:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1758);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1750)("4cf97dc3", content, true, {});

/***/ }),

/***/ 1758:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1749)(true);
// imports


// module
exports.push([module.i, ".invoiceExpansion .v-expansion-panel__header{background-color:#15155d}.invoiceExpansion .v-icon{color:#fff}", "", {"version":3,"sources":["D:/Acuify_Child_Products/Temp/src/components/Buyers/Invoice/InvoiceScreen.vue"],"names":[],"mappings":"AACA,6CACE,wBAA0B,CAC3B,AACD,0BACE,UAAa,CACd","file":"InvoiceScreen.vue","sourcesContent":["\n.invoiceExpansion .v-expansion-panel__header {\r\n  background-color: #15155d;\n}\n.invoiceExpansion .v-icon {\r\n  color: white;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1759:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddItem_vue__ = __webpack_require__(1754);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_043f28f8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddItem_vue__ = __webpack_require__(1760);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_043f28f8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1760:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cotainer',[_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"outline":""},on:{"click":_vm.addProduct}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\r\n          NEW PRODUCT\r\n      ")],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.scanItem()}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("qr_code_scanner")]),_vm._v("\r\n          SCAN\r\n      ")],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.getHeaders,"items":_vm.allItems,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.productName))]),_vm._v(" "),(_vm.gstInvoice)?_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.HSN_code))]):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v(_vm._s(props.item.taxableGST_rate))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.rate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.unit))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.basicPrice))]),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v(_vm._s(props.item.GSTValue))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.tradeDiscount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.totlePrice))]),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v(_vm._s(props.item.CGST_val)+" ₹ ("+_vm._s(props.item.CGST)+" %)")]):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v(_vm._s(props.item.SGST_val)+" ₹ ("+_vm._s(props.item.SGST)+" %)")]):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v(_vm._s(props.item.IGST_val)+" ₹ ("+_vm._s(props.item.IGST)+" %)")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm5":"","md5":""}},[_c('v-select',{attrs:{"items":_vm.productsByBrand,"item-text":"name","return-object":"","autocomplete":"","label":"Products"},on:{"change":_vm.productChange},model:{value:(_vm.item.productName),callback:function ($$v) {_vm.$set(_vm.item, "productName", $$v)},expression:"item.productName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":"","md1":""}},[(_vm.item.productName)?_c('v-text-field',{attrs:{"type":"number","value":_vm.selectedProduct.quantity,"disabled":true,"label":"Available Quantity"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-select',{attrs:{"items":_vm.units,"label":"Unit"},model:{value:(_vm.item.unit),callback:function ($$v) {_vm.$set(_vm.item, "unit", $$v)},expression:"item.unit"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[(_vm.item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Quantity"},model:{value:(_vm.item.quantity),callback:function ($$v) {_vm.$set(_vm.item, "quantity", _vm._n($$v))},expression:"item.quantity"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[(_vm.item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Product Rate"},model:{value:(_vm.item.rate),callback:function ($$v) {_vm.$set(_vm.item, "rate", _vm._n($$v))},expression:"item.rate"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Basic Price"},model:{value:(_vm.item.basicPrice),callback:function ($$v) {_vm.$set(_vm.item, "basicPrice", _vm._n($$v))},expression:"item.basicPrice"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"GST Value"},model:{value:(_vm.item.GSTValue),callback:function ($$v) {_vm.$set(_vm.item, "GSTValue", _vm._n($$v))},expression:"item.GSTValue"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Total Price"},model:{value:(_vm.item.totlePrice),callback:function ($$v) {_vm.$set(_vm.item, "totlePrice", _vm._n($$v))},expression:"item.totlePrice"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"text","label":"Batch number","disabled":_vm.isBuyer},model:{value:(_vm.item.batchNumber),callback:function ($$v) {_vm.$set(_vm.item, "batchNumber", _vm._n($$v))},expression:"item.batchNumber"}}):_vm._e()],1),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerExp),callback:function ($$v) {_vm.datepickerExp=$$v},expression:"datepickerExp"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Expiry date","prepend-icon":"event","disabled":_vm.isBuyer,"readonly":""},slot:"activator",model:{value:(_vm.item.expiryDate),callback:function ($$v) {_vm.$set(_vm.item, "expiryDate", $$v)},expression:"item.expiryDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerExp = false}},model:{value:(_vm.item.expiryDate),callback:function ($$v) {_vm.$set(_vm.item, "expiryDate", $$v)},expression:"item.expiryDate"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerMen),callback:function ($$v) {_vm.datepickerMen=$$v},expression:"datepickerMen"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Manufacturing date","prepend-icon":"event","disabled":_vm.isBuyer,"readonly":""},slot:"activator",model:{value:(_vm.item.manufacturingDate),callback:function ($$v) {_vm.$set(_vm.item, "manufacturingDate", $$v)},expression:"item.manufacturingDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerMen = false}},model:{value:(_vm.item.manufacturingDate),callback:function ($$v) {_vm.$set(_vm.item, "manufacturingDate", $$v)},expression:"item.manufacturingDate"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-switch',{attrs:{"label":("Trade Discount in: " + (_vm.isTradePercentage ? '%' : '₹'))},model:{value:(_vm.isTradePercentage),callback:function ($$v) {_vm.isTradePercentage=$$v},expression:"isTradePercentage"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate && _vm.isTradePercentage)?_c('v-text-field',{attrs:{"type":"number","suffix":"%","label":"Trade Discount"},on:{"keyup":function($event){return _vm.calculateTradeDiscount()}},model:{value:(_vm.tradeDiscountPercentage),callback:function ($$v) {_vm.tradeDiscountPercentage=_vm._n($$v)},expression:"tradeDiscountPercentage"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","suffix":"₹","disabled":_vm.isTradePercentage,"label":"Trade Discount"},model:{value:(_vm.item.tradeDiscount),callback:function ($$v) {_vm.$set(_vm.item, "tradeDiscount", _vm._n($$v))},expression:"item.tradeDiscount"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-select',{attrs:{"dense":"","items":_vm.godawnByBrand,"label":"Via Godawn"},model:{value:(_vm.item.godawnBy),callback:function ($$v) {_vm.$set(_vm.item, "godawnBy", $$v)},expression:"item.godawnBy"}}):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"grey darken-1",nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Back")]),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"disabled":!(_vm.item.productName && _vm.item.quantity && _vm.item.rate)},nativeOn:{"click":function($event){return _vm.save(false)}}},[_vm._v("Save")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"success white--text","disabled":!(_vm.item.productName && _vm.item.quantity && _vm.item.rate)},nativeOn:{"click":function($event){return _vm.save(true)}}},[_vm._v("Save & Add Another item")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":""},model:{value:(_vm.addProductDialog),callback:function ($$v) {_vm.addProductDialog=$$v},expression:"addProductDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Product Details")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.addProductDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-stepper',{attrs:{"vertical":""},model:{value:(_vm.stepper),callback:function ($$v) {_vm.stepper=$$v},expression:"stepper"}},[_c('v-stepper-step',{attrs:{"complete":_vm.stepper > 1,"step":"1"}},[_vm._v("Step : 1 "),_c('h3',{staticClass:"error--text text--darken-4"},[_vm._v(_vm._s(_vm.duplicateError))])]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-card',{staticClass:"mb-12",staticStyle:{"height":"100%"}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-combobox',{attrs:{"items":_vm.productsByBrand,"return-object":false,"item-text":"name","item-value":"name","label":"Product Name","placeholder":"Enter Product name"},on:{"change":function($event){return _vm.duplicateCheck()}},model:{value:(_vm.currentProduct.name),callback:function ($$v) {_vm.$set(_vm.currentProduct, "name", $$v)},expression:"currentProduct.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Product Description"},model:{value:(_vm.currentProduct.description),callback:function ($$v) {_vm.$set(_vm.currentProduct, "description", $$v)},expression:"currentProduct.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"type":"number","dense":"","items":_vm.GST_types,"label":"Select GST type"},model:{value:(_vm.currentProduct.GST_type),callback:function ($$v) {_vm.$set(_vm.currentProduct, "GST_type", $$v)},expression:"currentProduct.GST_type"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"dense":"","items":[3,5,12,18,28],"disabled":_vm.currentProduct.GST_type != 'TAXABLE',"label":"Taxable GST rate"},model:{value:(_vm.currentProduct.taxableGST_rate),callback:function ($$v) {_vm.$set(_vm.currentProduct, "taxableGST_rate", $$v)},expression:"currentProduct.taxableGST_rate"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"type":"number","label":"HSN code"},model:{value:(_vm.currentProduct.HSN_code),callback:function ($$v) {_vm.$set(_vm.currentProduct, "HSN_code", $$v)},expression:"currentProduct.HSN_code"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.units,"label":"Select unit"},model:{value:(_vm.currentProduct.unit),callback:function ($$v) {_vm.$set(_vm.currentProduct, "unit", $$v)},expression:"currentProduct.unit"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.stepper = 2}}},[_vm._v("Next")])],1)],1)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.stepper > 2,"step":"2"}},[_vm._v("Step : 2")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-card',{staticClass:"mb-12",staticStyle:{"height":"100%"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{attrs:{"dense":"","items":[
                          {
                            text: 'Yes',
                            value: true
                          },
                          {
                            text: 'No',
                            value: false
                          } ],"label":"Do you have Opening Balance Of Product?"},model:{value:(_vm.isOpeningBalance),callback:function ($$v) {_vm.isOpeningBalance=$$v},expression:"isOpeningBalance"}})],1)],1),_vm._v(" "),(_vm.isOpeningBalance)?_c('v-layout',{attrs:{"wrap":""}},[(_vm.isOpeningBalance)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.currentProduct.openingDate),callback:function ($$v) {_vm.$set(_vm.currentProduct, "openingDate", $$v)},expression:"currentProduct.openingDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.currentProduct.openingDate),callback:function ($$v) {_vm.$set(_vm.currentProduct, "openingDate", $$v)},expression:"currentProduct.openingDate"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Opening Quantity"},model:{value:(_vm.currentProduct.quantity),callback:function ($$v) {_vm.$set(_vm.currentProduct, "quantity", $$v)},expression:"currentProduct.quantity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Opening Amount"},model:{value:(_vm.currentProduct.openingBalance),callback:function ($$v) {_vm.$set(_vm.currentProduct, "openingBalance", $$v)},expression:"currentProduct.openingBalance"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-text-field',{attrs:{"disabled":true,"type":"number","value":(Number.parseFloat((_vm.currentProduct.openingBalance * 100) / (_vm.currentProduct.taxableGST_rate + 100))).toFixed(2),"label":"Basic Value"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-text-field',{attrs:{"disabled":true,"type":"number","value":(Number.parseFloat ((_vm.currentProduct.openingBalance || 0) - ((_vm.currentProduct.openingBalance * 100) / (_vm.currentProduct.taxableGST_rate + 100)))).toFixed(2),"label":"GST Value"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.stepper = 3}}},[_vm._v("Next")]),_vm._v(" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.stepper = 1}}},[_vm._v("Back")])],1)],1)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.stepper > 3,"step":"3"}},[_vm._v("Step : 3")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-card',{staticClass:"mb-12",staticStyle:{"height":"100%"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{attrs:{"dense":"","items":[
                          {
                            text: 'Yes',
                            value: true
                          },
                          {
                            text: 'No',
                            value: false
                          } ],"label":"Do you want to add Standard Price of the Product?"},model:{value:(_vm.isStanderedPrice),callback:function ($$v) {_vm.isStanderedPrice=$$v},expression:"isStanderedPrice"}})],1),_vm._v(" "),(_vm.isStanderedPrice)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{attrs:{"dense":"","disabled":true,"items":_vm.units,"label":"Select unit"},model:{value:(_vm.currentProduct.unit),callback:function ($$v) {_vm.$set(_vm.currentProduct, "unit", $$v)},expression:"currentProduct.unit"}})],1):_vm._e(),_vm._v(" "),(_vm.isStanderedPrice)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{attrs:{"dense":"","items":[3,5,12,18,28],"disabled":true,"label":"Taxable GST rate"},model:{value:(_vm.currentProduct.taxableGST_rate),callback:function ($$v) {_vm.$set(_vm.currentProduct, "taxableGST_rate", $$v)},expression:"currentProduct.taxableGST_rate"}})],1):_vm._e()],1),_vm._v(" "),(_vm.isStanderedPrice)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Purchasing Price [Excluding GST]"},model:{value:(_vm.currentProduct.purchasingPrice),callback:function ($$v) {_vm.$set(_vm.currentProduct, "purchasingPrice", $$v)},expression:"currentProduct.purchasingPrice"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":true,"value":_vm.currentProduct.taxableGST_rate ? (Number.parseFloat((_vm.currentProduct.purchasingPrice * _vm.currentProduct.taxableGST_rate)/100) + Number.parseFloat(_vm.currentProduct.purchasingPrice)).toFixed(2) : _vm.currentProduct.purchasingPrice,"label":"Purchasing Price [Including GST]"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Selling Price [Excluding GST]"},model:{value:(_vm.currentProduct.sellingPrice),callback:function ($$v) {_vm.$set(_vm.currentProduct, "sellingPrice", $$v)},expression:"currentProduct.sellingPrice"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":true,"value":_vm.currentProduct.taxableGST_rate ? (Number.parseFloat((_vm.currentProduct.sellingPrice * _vm.currentProduct.taxableGST_rate)/100) + Number.parseFloat(_vm.currentProduct.sellingPrice)).toFixed(2) : _vm.currentProduct.sellingPrice,"label":"Selling Price [Including GST]"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.stepper = 2}}},[_vm._v("Back")]),_vm._v(" "),(!_vm.currentProduct['.key'])?_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.saveProduct}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),(!!_vm.currentProduct['.key'])?_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.updateProduct}},[_vm._v("Update")]):_vm._e()],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"800px"},model:{value:(_vm.scannerDialog),callback:function ($$v) {_vm.scannerDialog=$$v},expression:"scannerDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Scan Barcode of Product")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('section',{staticClass:"container",attrs:{"id":"container"}},[_c('label',[_c('span',[_vm._v("Camera")]),_vm._v(" "),_c('select',{attrs:{"name":"input-stream_constraints","id":"deviceSelection"}})]),_vm._v(" "),_c('div',{staticClass:"viewport",attrs:{"id":"interactive"}})])])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.scannerDialog = false}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"top":"","color":"primary"},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\r\n    Product is added.\r\n    ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1761:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrintInvoice_vue__ = __webpack_require__(1755);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39d6dcbc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrintInvoice_vue__ = __webpack_require__(1762);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrintInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39d6dcbc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrintInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1762:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"background-color":"#f1f1f1"},attrs:{"flat":""}},[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"prefix":"#","label":"Alert (in Days)","readonly":""},model:{value:(_vm.invoiceData.duration),callback:function ($$v) {_vm.$set(_vm.invoiceData, "duration", $$v)},expression:"invoiceData.duration"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"prefix":"#","label":"Invoice Id","readonly":""},model:{value:(_vm.invoiceData.invoiceId),callback:function ($$v) {_vm.$set(_vm.invoiceData, "invoiceId", $$v)},expression:"invoiceData.invoiceId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","offset-xs6":""}},[_c('v-text-field',{attrs:{"label":"Invoice Date","readonly":"","value":new Date(_vm.invoiceData.date).toLocaleDateString('en-GB')}})],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.Itemheaders,"items":_vm.invoiceData.items,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.productName))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.HSN_code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.taxableGST_rate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.rate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.unit))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.basicPrice))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.GSTValue))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.totlePrice))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.CGST_val)+" ₹ ("+_vm._s(props.item.CGST)+" %)")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.SGST_val)+" ₹ ("+_vm._s(props.item.SGST)+" %)")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.IGST_val)+" ₹ ("+_vm._s(props.item.IGST)+" %)")])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-tabs',{attrs:{"centered":"","icons-and-text":"","background-color":"primary"},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab',{attrs:{"href":"#tab-1"}},[_vm._v("E-WAY BILL")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-2"}},[_vm._v("VIEW E-WAY BILL")])],1),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',{attrs:{"value":'tab-1'}},[_c('v-layout',{staticStyle:{"margin":"20px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":"","s6":"","md3":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":""}},[_c('h3',{attrs:{"color":"primary"}},[_vm._v("E-WAY DETAILS")])]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"label":"E-way Bill no"},model:{value:(_vm.ebillDetails.billNo),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "billNo", $$v)},expression:"ebillDetails.billNo"}}),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerBillDate),callback:function ($$v) {_vm.datepickerBillDate=$$v},expression:"datepickerBillDate"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"E-way Bill Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.ebillDetails.billDate),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "billDate", $$v)},expression:"ebillDetails.billDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerBillDate = false}},model:{value:(_vm.ebillDetails.billDate),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "billDate", $$v)},expression:"ebillDetails.billDate"}})],1),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":"","label":"Generated By"},model:{value:(_vm.ebillDetails.generatedBy),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "generatedBy", $$v)},expression:"ebillDetails.generatedBy"}}),_vm._v(" "),_c('v-text-field',{attrs:{"slot":"activator","label":"Valid From","prepend-icon":"event","value":new Date(_vm.invoiceData.date).toLocaleDateString('en-GB'),"disabled":""},slot:"activator"}),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerValidUntil),callback:function ($$v) {_vm.datepickerValidUntil=$$v},expression:"datepickerValidUntil"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Valid Untill","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.ebillDetails.validUntil),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "validUntil", $$v)},expression:"ebillDetails.validUntil"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerValidUntil = false}},model:{value:(_vm.ebillDetails.validUntil),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "validUntil", $$v)},expression:"ebillDetails.validUntil"}})],1)],1)],1)],1),_vm._v(" "),(_vm.customer)?_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":"","s6":"","md3":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":""}},[_c('h3',{attrs:{"color":"primary"}},[_vm._v("RECEIPIENT DETAILS")])]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"disabled":"","label":"Firm Name"},model:{value:(_vm.customer.name),callback:function ($$v) {_vm.$set(_vm.customer, "name", $$v)},expression:"customer.name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":"","label":"Proprietor Name"},model:{value:(_vm.customer.propName),callback:function ($$v) {_vm.$set(_vm.customer, "propName", $$v)},expression:"customer.propName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":"","label":"GST Number"},model:{value:(_vm.customer.GST_number),callback:function ($$v) {_vm.$set(_vm.customer, "GST_number", $$v)},expression:"customer.GST_number"}}),_vm._v(" "),_c('v-textarea',{attrs:{"disabled":"","box":"","label":"Address"},model:{value:(_vm.customer.address),callback:function ($$v) {_vm.$set(_vm.customer, "address", $$v)},expression:"customer.address"}}),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":"","label":"Mobile Number"},model:{value:(_vm.customer.mobile),callback:function ($$v) {_vm.$set(_vm.customer, "mobile", $$v)},expression:"customer.mobile"}}),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":"","label":"State State"},model:{value:(_vm.customer.state),callback:function ($$v) {_vm.$set(_vm.customer, "state", $$v)},expression:"customer.state"}}),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":"","label":"State Code"},model:{value:(_vm.customer.stateCode),callback:function ($$v) {_vm.$set(_vm.customer, "stateCode", $$v)},expression:"customer.stateCode"}}),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":"","label":"Email"},model:{value:(_vm.customer.email),callback:function ($$v) {_vm.$set(_vm.customer, "email", $$v)},expression:"customer.email"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.consignee)?_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":"","s6":"","md3":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":""}},[_c('h3',{attrs:{"color":"primary"}},[_vm._v("CONSIGNEE DETAILS")])]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Firm Name"},model:{value:(_vm.consignee.name),callback:function ($$v) {_vm.$set(_vm.consignee, "name", $$v)},expression:"consignee.name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Proprietor Name"},model:{value:(_vm.consignee.propName),callback:function ($$v) {_vm.$set(_vm.consignee, "propName", $$v)},expression:"consignee.propName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"GST Number"},model:{value:(_vm.consignee.GST_number),callback:function ($$v) {_vm.$set(_vm.consignee, "GST_number", $$v)},expression:"consignee.GST_number"}}),_vm._v(" "),_c('v-textarea',{attrs:{"box":"","label":"Address"},model:{value:(_vm.consignee.address),callback:function ($$v) {_vm.$set(_vm.consignee, "address", $$v)},expression:"consignee.address"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Mobile Number","rules":_vm.mobile.rules},model:{value:(_vm.consignee.mobile),callback:function ($$v) {_vm.$set(_vm.consignee, "mobile", $$v)},expression:"consignee.mobile"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"State State"},model:{value:(_vm.consignee.state),callback:function ($$v) {_vm.$set(_vm.consignee, "state", $$v)},expression:"consignee.state"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"State Code"},model:{value:(_vm.consignee.stateCode),callback:function ($$v) {_vm.$set(_vm.consignee, "stateCode", $$v)},expression:"consignee.stateCode"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Email"},model:{value:(_vm.consignee.email),callback:function ($$v) {_vm.$set(_vm.consignee, "email", $$v)},expression:"consignee.email"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":"","s6":"","md3":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":""}},[_c('h3',{attrs:{"color":"primary"}},[_vm._v("TRANSPORTATION DETAILS")])]),_vm._v(" "),_c('v-card-text',[_c('v-select',{attrs:{"items":['Road','Train','Aeroplane'],"label":"Mode of Transport"},model:{value:(_vm.ebillDetails.transportationDetails.mode),callback:function ($$v) {_vm.$set(_vm.ebillDetails.transportationDetails, "mode", $$v)},expression:"ebillDetails.transportationDetails.mode"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Vehicle Number"},model:{value:(_vm.transportationDetails.vehicleNo),callback:function ($$v) {_vm.$set(_vm.transportationDetails, "vehicleNo", $$v)},expression:"transportationDetails.vehicleNo"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Driver Name"},model:{value:(_vm.transportationDetails.driverName),callback:function ($$v) {_vm.$set(_vm.transportationDetails, "driverName", $$v)},expression:"transportationDetails.driverName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Driver Mobile Number","rules":_vm.mobile.rules},model:{value:(_vm.transportationDetails.driverNumber),callback:function ($$v) {_vm.$set(_vm.transportationDetails, "driverNumber", $$v)},expression:"transportationDetails.driverNumber"}}),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":"","label":"GSTIN of Supplier"},model:{value:(_vm.ebillDetails.GSTofSupplier),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "GSTofSupplier", $$v)},expression:"ebillDetails.GSTofSupplier"}}),_vm._v(" "),_c('v-textarea',{attrs:{"box":"","label":"Place Of Dispatch","readonly":""},model:{value:(_vm.firm.address),callback:function ($$v) {_vm.$set(_vm.firm, "address", $$v)},expression:"firm.address"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"GSTIN of Receipient/Consignee"},model:{value:(_vm.ebillDetails.GSTofReceipient),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "GSTofReceipient", $$v)},expression:"ebillDetails.GSTofReceipient"}}),_vm._v(" "),_c('v-textarea',{attrs:{"box":"","label":"Place Of Delivery","readonly":""},model:{value:(_vm.consignee.address),callback:function ($$v) {_vm.$set(_vm.consignee, "address", $$v)},expression:"consignee.address"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":""}},[_c('v-btn',{staticClass:"primary white--text",attrs:{"flat":""},on:{"click":function($event){return _vm.printInvoice()}}},[_vm._v("Print")])],1)],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"value":'tab-2'}},[_c('v-layout',{staticStyle:{"margin":"20px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":"","s6":"","md4":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":""}},[_c('h3',{attrs:{"color":"primary"}},[_vm._v("E-WAY DETAILS")])]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"label":"E-way Bill no"},model:{value:(_vm.ebillDetails.billNo),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "billNo", $$v)},expression:"ebillDetails.billNo"}}),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerBillDate),callback:function ($$v) {_vm.datepickerBillDate=$$v},expression:"datepickerBillDate"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"E-way Bill Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.ebillDetails.billDate),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "billDate", $$v)},expression:"ebillDetails.billDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerBillDate = false}},model:{value:(_vm.ebillDetails.billDate),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "billDate", $$v)},expression:"ebillDetails.billDate"}})],1),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":"","label":"Generated By"},model:{value:(_vm.ebillDetails.generatedBy),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "generatedBy", $$v)},expression:"ebillDetails.generatedBy"}}),_vm._v(" "),_c('v-text-field',{attrs:{"slot":"activator","label":"Valid From","prepend-icon":"event","value":new Date(_vm.invoiceData.date).toLocaleDateString('en-GB'),"disabled":""},slot:"activator"}),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerValidUntil),callback:function ($$v) {_vm.datepickerValidUntil=$$v},expression:"datepickerValidUntil"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Valid Untill","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.ebillDetails.validUntil),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "validUntil", $$v)},expression:"ebillDetails.validUntil"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerValidUntil = false}},model:{value:(_vm.ebillDetails.validUntil),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "validUntil", $$v)},expression:"ebillDetails.validUntil"}})],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":"","s6":"","md4":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":""}},[_c('h3',{attrs:{"color":"primary"}},[_vm._v("PART - A")])]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"disabled":"","label":"GSTIN of Supplier"},model:{value:(_vm.ebillDetails.GSTofSupplier),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "GSTofSupplier", $$v)},expression:"ebillDetails.GSTofSupplier"}}),_vm._v(" "),_c('v-textarea',{attrs:{"box":"","label":"Place Of Dispatch","readonly":""},model:{value:(_vm.firm.address),callback:function ($$v) {_vm.$set(_vm.firm, "address", $$v)},expression:"firm.address"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"GSTIN of Receipient/Consignee"},model:{value:(_vm.ebillDetails.GSTofReceipient),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "GSTofReceipient", $$v)},expression:"ebillDetails.GSTofReceipient"}}),_vm._v(" "),_c('v-textarea',{attrs:{"box":"","label":"Place Of Delivery","readonly":""},model:{value:(_vm.consignee.address),callback:function ($$v) {_vm.$set(_vm.consignee, "address", $$v)},expression:"consignee.address"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Document No"},model:{value:(_vm.ebillDetails.documentNo),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "documentNo", $$v)},expression:"ebillDetails.documentNo"}}),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerDocumentDate),callback:function ($$v) {_vm.datepickerDocumentDate=$$v},expression:"datepickerDocumentDate"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Document Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.ebillDetails.documentDate),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "documentDate", $$v)},expression:"ebillDetails.documentDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerDocumentDate = false}},model:{value:(_vm.ebillDetails.documentDate),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "documentDate", $$v)},expression:"ebillDetails.documentDate"}})],1),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Value Of Goods"},model:{value:(_vm.ebillDetails.valueOfGoods),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "valueOfGoods", $$v)},expression:"ebillDetails.valueOfGoods"}}),_vm._v(" "),_c('v-textarea',{attrs:{"box":"","label":"Reason Of Transportation"},model:{value:(_vm.ebillDetails.reasonOfTransportation),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "reasonOfTransportation", $$v)},expression:"ebillDetails.reasonOfTransportation"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":"","s6":"","md4":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":""}},[_c('h3',{attrs:{"color":"primary"}},[_vm._v("PART - B")])]),_vm._v(" "),_c('v-card-text',[_c('v-select',{attrs:{"items":['Road','Train','Aeroplane'],"label":"Mode of Transport"},model:{value:(_vm.ebillDetails.transportationDetails.mode),callback:function ($$v) {_vm.$set(_vm.ebillDetails.transportationDetails, "mode", $$v)},expression:"ebillDetails.transportationDetails.mode"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Vehicle No"},model:{value:(_vm.ebillDetails.transportationDetails.vehicleNo),callback:function ($$v) {_vm.$set(_vm.ebillDetails.transportationDetails, "vehicleNo", $$v)},expression:"ebillDetails.transportationDetails.vehicleNo"}}),_vm._v(" "),_c('v-textarea',{attrs:{"box":"","label":"From Address","readonly":""},on:{"click":function($event){return _vm.addressDialogOpen('transportationDetails','from')}},model:{value:(_vm.firm.address),callback:function ($$v) {_vm.$set(_vm.firm, "address", $$v)},expression:"firm.address"}}),_vm._v(" "),_c('v-textarea',{attrs:{"box":"","label":"To Address","readonly":""},on:{"click":function($event){return _vm.addressDialogOpen('transportationDetails','to')}},model:{value:(_vm.consignee.address),callback:function ($$v) {_vm.$set(_vm.consignee, "address", $$v)},expression:"consignee.address"}}),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerDepartureDate),callback:function ($$v) {_vm.datepickerDepartureDate=$$v},expression:"datepickerDepartureDate"}},[_c('v-text-field',{attrs:{"slot":"activator","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.ebillDetails.billDate),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "billDate", $$v)},expression:"ebillDetails.billDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerBillDate = false}},model:{value:(_vm.ebillDetails.billDate),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "billDate", $$v)},expression:"ebillDetails.billDate"}})],1),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Entered By"},model:{value:(_vm.ebillDetails.transportationDetails.enteredBy),callback:function ($$v) {_vm.$set(_vm.ebillDetails.transportationDetails, "enteredBy", $$v)},expression:"ebillDetails.transportationDetails.enteredBy"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"CEWB Number"},model:{value:(_vm.ebillDetails.transportationDetails.CEWBno),callback:function ($$v) {_vm.$set(_vm.ebillDetails.transportationDetails, "CEWBno", $$v)},expression:"ebillDetails.transportationDetails.CEWBno"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"800px"},model:{value:(_vm.addressDialog),callback:function ($$v) {_vm.addressDialog=$$v},expression:"addressDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Select Address")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.gVillage,"label":"Village"},model:{value:(_vm.address.village),callback:function ($$v) {_vm.$set(_vm.address, "village", $$v)},expression:"address.village"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.gBlock,"label":"Block"},model:{value:(_vm.address.block),callback:function ($$v) {_vm.$set(_vm.address, "block", $$v)},expression:"address.block"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.gTehsil,"label":"Tehsil"},model:{value:(_vm.address.tehsil),callback:function ($$v) {_vm.$set(_vm.address, "tehsil", $$v)},expression:"address.tehsil"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.gDistrict,"label":"District"},model:{value:(_vm.address.district),callback:function ($$v) {_vm.$set(_vm.address, "district", $$v)},expression:"address.district"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.gState,"item-text":"state","label":"State"},model:{value:(_vm.address.state),callback:function ($$v) {_vm.$set(_vm.address, "state", $$v)},expression:"address.state"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Full Address"},model:{value:(_vm.address.fullAddress),callback:function ($$v) {_vm.$set(_vm.address, "fullAddress", $$v)},expression:"address.fullAddress"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.addressDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.setAddress($event)}}},[_vm._v("Save")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1763:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-layout',{staticStyle:{"margin-top":"-20px"},attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('h2',{staticClass:"title error--text text--darken-4"},[_vm._v(_vm._s(this.currentUser.name))]),_vm._v(" "),_c('h4',{staticClass:"font-weight-light error--text text--darken-4"},[_vm._v(_vm._s(this.currentUser.GST_number))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"prefix":"#","label":"Invoice Number","readonly":_vm.isSummary,"placeholder":"Invoice Number"},on:{"change":function($event){return _vm.duplicateCheckInvoiceId()}},model:{value:(_vm.invoiceId),callback:function ($$v) {_vm.invoiceId=$$v},expression:"invoiceId"}}),_vm._v(" "),_c('h3',{staticClass:"error--text text--darken-4"},[_vm._v(_vm._s(_vm.duplicateError))])],1),_vm._v(" "),(!((new Date(_vm.invoiceDate).getTime() >= _vm.finYear.start) && (new Date(_vm.invoiceDate).getTime() <= _vm.finYear.end)))?_c('h3',{staticClass:"error--text text--darken-4"},[_vm._v("This invoice is not in current financial year.")]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.invoiceDate),callback:function ($$v) {_vm.invoiceDate=$$v},expression:"invoiceDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"readonly":_vm.isSummary},on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.invoiceDate),callback:function ($$v) {_vm.invoiceDate=$$v},expression:"invoiceDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-text-field',{attrs:{"prefix":"#","label":"Alert (in Days)","readonly":_vm.isSummary},model:{value:(_vm.alertDuration),callback:function ($$v) {_vm.alertDuration=$$v},expression:"alertDuration"}})],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.getHeaders,"items":_vm.items,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.productName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.rate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.unit))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.basicPrice))]),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v(_vm._s(props.item.GSTValue))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.tradeDiscount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.totlePrice))]),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v(_vm._s(props.item.CGST_val)+" ₹ ("+_vm._s(props.item.CGST)+" %)")]):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v(_vm._s(props.item.SGST_val)+" ₹ ("+_vm._s(props.item.SGST)+" %)")]):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v(_vm._s(props.item.IGST_val)+" ₹ ("+_vm._s(props.item.IGST)+" %)")]):_vm._e(),_vm._v(" "),(!_vm.isSummary)?_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item,false)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1):_vm._e()]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2),_vm._v(" "),(!_vm.isSummary)?_c('v-card-actions',[_c('v-dialog',{attrs:{"persistent":"","max-width":"1200px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-btn',{staticClass:"primary white--text",attrs:{"slot":"activator","flat":""},slot:"activator"},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\n        New Item\n      ")],1),_vm._v(" "),_c('add-item',{attrs:{"editedItem":_vm.editedItem,"buyerId":_vm.buyerId,"allItems":_vm.items,"isEditItems":_vm.isEditItems,"gstInvoice":_vm.gstInvoice},on:{"closeAddItem":_vm.close,"saveAddItem":_vm.save,"editItem":_vm.editItem,"deleteItem":_vm.deleteItem}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.selectedFirm && _vm.transactionType)?_c('v-btn',{staticClass:"primary white--text",attrs:{"disabled":!_vm.formIsValid,"flat":""},nativeOn:{"click":function($event){return _vm.$emit('next')}}},[_vm._v("Next and confirm\n      "),_c('v-icon',[_vm._v("arrow_right_alt")])],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isSummary)?_c('v-card-actions',[_c('v-btn',{staticClass:"grey white--text",attrs:{"flat":""},nativeOn:{"click":function($event){return _vm.$emit('back')}}},[_vm._v("Back")]),_vm._v(" "),_c('v-btn',{staticClass:"error white--text",attrs:{"flat":""},on:{"click":function($event){return _vm.print()}}},[_vm._v("E-way Bill")]),_vm._v(" "),_c('v-btn',{staticClass:"warning white--text",attrs:{"flat":""},on:{"click":function($event){return _vm.basicInvoicePrint()}}},[_vm._v("Basic Print")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"info white--text",attrs:{"flat":""},nativeOn:{"click":function($event){return _vm.saveAndPrint()}}},[_vm._v("Save & Print")]),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"flat":""},nativeOn:{"click":function($event){return _vm.saveInvoice()}}},[_vm._v("Save Invoice")])],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.transactionDialog),callback:function ($$v) {_vm.transactionDialog=$$v},expression:"transactionDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Payment Details\n          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.transactionDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Total Amount (in ₹)","readonly":"","value":_vm.totalAmount,"prefix":""}}),_vm._v(" "),_c('v-select',{attrs:{"dense":"","readonly":_vm.isSummary,"items":[{
                          text: 'Cash',
                          value: 'Cash'
                        }, {
                          text: 'Bank Account',
                          value: 'Bank Account'
                        }, {
                          text: 'Cash & Bank Account',
                          value: 'CashAndBank Account'
                        }],"label":"Select Payment Type"},on:{"change":function($event){return _vm.resetAmounts()}},model:{value:(_vm.paymentType),callback:function ($$v) {_vm.paymentType=$$v},expression:"paymentType"}}),_vm._v(" "),(['Bank Account','CashAndBank Account'].includes(_vm.paymentType))?_c('v-select',{attrs:{"dense":"","items":_vm.banksByFirms,"label":"Select Bank","readonly":_vm.isSummary,"disabled":_vm.paymentType == 'Cash' || _vm.paymentType == ''},model:{value:(_vm.selectedBank),callback:function ($$v) {_vm.selectedBank=$$v},expression:"selectedBank"}}):_vm._e(),_vm._v(" "),(['Bank Account','CashAndBank Account'].includes(_vm.paymentType))?_c('v-select',{attrs:{"dense":"","disabled":_vm.paymentType == 'Cash' || _vm.paymentType == '',"readonly":_vm.isSummary,"items":[{
                    text: 'Cheque',
                    value: 'Cheque'
                  }, {
                    text: 'NEFT',
                    value: 'NEFT'
                  }, {
                    text: 'RTGS',
                    value: 'RTGS'
                  }, {
                    text: 'IMPS',
                    value: 'IMPS'
                  }],"label":"Select Transfer type"},on:{"input":function($event){_vm.transferTypeDialog = true}},model:{value:(_vm.transferType),callback:function ($$v) {_vm.transferType=$$v},expression:"transferType"}}):_vm._e(),_vm._v(" "),(['Cash', 'CashAndBank Account'].includes(_vm.paymentType))?_c('v-text-field',{attrs:{"readonly":_vm.isSummary,"type":"number","disabled":_vm.amountFromCashDisabled,"label":"Amount from Cash"},model:{value:(_vm.amountFromCash),callback:function ($$v) {_vm.amountFromCash=$$v},expression:"amountFromCash"}}):_vm._e(),_vm._v(" "),(['Bank Account','CashAndBank Account'].includes(_vm.paymentType))?_c('v-text-field',{attrs:{"readonly":_vm.isSummary,"type":"number","disabled":_vm.amountFromBankDisabled,"label":"Amount from Bank"},model:{value:(_vm.amountFromBank),callback:function ($$v) {_vm.amountFromBank=$$v},expression:"amountFromBank"}}):_vm._e(),_vm._v(" "),(_vm.remainingAmount > 0)?_c('v-text-field',{attrs:{"type":"number","label":"Remaining Amount (in ₹)","readonly":"","prefix":""},model:{value:(_vm.remainingAmount),callback:function ($$v) {_vm.remainingAmount=$$v},expression:"remainingAmount"}}):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":"","disabled":!_vm.paymentType},nativeOn:{"click":function($event){_vm.transactionDialog = false}}},[_vm._v("Confirm")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.transferTypeDialog),callback:function ($$v) {_vm.transferTypeDialog=$$v},expression:"transferTypeDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("\n          Transfer Information\n          "),_c('b',[_vm._v(_vm._s(_vm.transferType))])])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","label":"A/C Number"},model:{value:(_vm.transferDetails.accountNumber),callback:function ($$v) {_vm.$set(_vm.transferDetails, "accountNumber", $$v)},expression:"transferDetails.accountNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"A/C Holder Name"},model:{value:(_vm.transferDetails.accountHolderName),callback:function ($$v) {_vm.$set(_vm.transferDetails, "accountHolderName", $$v)},expression:"transferDetails.accountHolderName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Bank Name"},model:{value:(_vm.transferDetails.bankName),callback:function ($$v) {_vm.$set(_vm.transferDetails, "bankName", $$v)},expression:"transferDetails.bankName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"IFSC Code"},model:{value:(_vm.transferDetails.IFSCcode),callback:function ($$v) {_vm.$set(_vm.transferDetails, "IFSCcode", $$v)},expression:"transferDetails.IFSCcode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Remark"},model:{value:(_vm.transferDetails.remark),callback:function ($$v) {_vm.$set(_vm.transferDetails, "remark", $$v)},expression:"transferDetails.remark"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.transferTypeDialog = false}}},[_vm._v("Ok")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"dense":"","flat":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","s12":"","md8":""}},[_c('v-expansion-panel',{staticClass:"invoiceExpansion"},[_c('v-expansion-panel-content',{attrs:{"value":_vm.expansionVal},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('v-card-title',[_c('h3',{staticClass:"title font-weight-light primary white--text"},[_vm._v("BASIC DETAILS")])])]},proxy:true}])},[_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"label":"Total Item","readonly":"","value":_vm.totalItems}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm","readonly":_vm.isSummary},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-select',{attrs:{"dense":"","readonly":_vm.isSummary,"items":[{
                        text: 'Due',
                        value: 'Debit'
                      }, {
                        text: 'Partial Paid',
                        value: 'Partial Paid'
                      }, {
                        text: 'Full Paid',
                        value: 'Credit'
                      }],"label":"Select Transaction type","disabled":!_vm.items.length},on:{"change":function($event){return _vm.resetAmounts()}},model:{value:(_vm.transactionType),callback:function ($$v) {_vm.transactionType=$$v},expression:"transactionType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Labour Charge"},model:{value:(_vm.labourAmount),callback:function ($$v) {_vm.labourAmount=$$v},expression:"labourAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Discount (in ₹)"},model:{value:(_vm.discountAmount),callback:function ($$v) {_vm.discountAmount=$$v},expression:"discountAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Round Off (in ₹)"},model:{value:(_vm.roundOffAmount),callback:function ($$v) {_vm.roundOffAmount=$$v},expression:"roundOffAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.staffByBrand,"label":"Sold By","readonly":_vm.isSummary},model:{value:(_vm.soldBy),callback:function ($$v) {_vm.soldBy=$$v},expression:"soldBy"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"type":"Number","label":"Brokerage Rate (in %)"},model:{value:(_vm.brokerageRate),callback:function ($$v) {_vm.brokerageRate=$$v},expression:"brokerageRate"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Brokerage Amount (in ₹)","disabled":"","value":Number.parseFloat(((Number.parseFloat(_vm.totalAmount)  - (Number.parseFloat(_vm.discountAmount))) * _vm.brokerageRate)/100).toFixed(2)}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.gState,"label":"Place of Supply","item-text":"state","readonly":_vm.isSummary},model:{value:(_vm.placeOfSupply),callback:function ($$v) {_vm.placeOfSupply=$$v},expression:"placeOfSupply"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-textarea',{attrs:{"box":"","label":"Remark","readonly":_vm.isSummary},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","s12":"","md4":""}},[_c('v-expansion-panel',{staticClass:"invoiceExpansion"},[_c('v-expansion-panel-content',{attrs:{"value":_vm.expansionVal},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',[_c('v-card-title',[_c('h3',{staticClass:"title font-weight-light primary white--text"},[_vm._v("INVOICE DETAILS")])])],1)]},proxy:true}])},[_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"margin-top":"-5px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v("Taxable Amount")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"readonly":"","value":((Number.parseFloat(_vm.totalAmount) - Number.parseFloat(_vm.roundOffAmount)) - (Number.parseFloat(_vm.GST_Val_total.SGST_val) + Number.parseFloat(_vm.GST_Val_total.CGST_val) + Number.parseFloat(_vm.GST_Val_total.IGST_val))).toFixed(2),"type":"number"}})],1),_vm._v(" "),(_vm.gstInvoice)?_c('v-flex',{staticStyle:{"margin-top":"-5px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v("CGST Amount")])]):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","s6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"readonly":"","value":_vm.GST_Val_total.CGST_val.toFixed(2),"type":"number"}})],1):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('v-flex',{staticStyle:{"margin-top":"-5px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v(" SGST Amount ")])]):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","s6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"readonly":"","value":_vm.GST_Val_total.SGST_val.toFixed(2),"type":"number"}})],1):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('v-flex',{staticStyle:{"margin-top":"-5px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v(" IGST Amount ")])]):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","s6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"readonly":"","value":_vm.GST_Val_total.IGST_val.toFixed(2),"type":"number"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"-5px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v(" Labour Charge: ")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","s6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"readonly":"","type":"number"},model:{value:(_vm.labourAmount),callback:function ($$v) {_vm.labourAmount=$$v},expression:"labourAmount"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"-5px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v(" Discount ")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","s6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"readonly":"","type":"number"},model:{value:(_vm.discountAmount),callback:function ($$v) {_vm.discountAmount=$$v},expression:"discountAmount"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"-5px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v(" Round Off ")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","s6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"readonly":"","type":"number"},model:{value:(_vm.roundOffAmount),callback:function ($$v) {_vm.roundOffAmount=$$v},expression:"roundOffAmount"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"-5px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v(" Invoice Amount ")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","s6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"type":"number","readonly":"","value":((Number.parseFloat(_vm.totalAmount) + Number.parseFloat(_vm.labourAmount || 0 | _vm.amount))  - (Number.parseFloat(_vm.discountAmount || 0 | _vm.amount))).toFixed(2)}})],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","s12":"","md12":""}},[_c('v-expansion-panel',{staticClass:"invoiceExpansion"},[_c('v-expansion-panel-content',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',[_c('v-card-title',[_c('h3',{staticClass:"title font-weight-light primary white--text"},[_vm._v("EXTRA DETAILS")])])],1)]},proxy:true}])},[_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","s12":"","md6":""}},[(_vm.gstInvoice)?_c('v-text-field',{attrs:{"readonly":"","value":_vm.GST_Percentage_total.GST_0,"type":"number","label":"Total GST(0%)"}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.gstInvoice)?_c('v-text-field',{attrs:{"readonly":"","value":_vm.GST_Percentage_total.GST_5,"type":"number","label":"Total GST(5%)"}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.gstInvoice)?_c('v-text-field',{attrs:{"readonly":"","value":_vm.GST_Percentage_total.GST_12,"type":"number","label":"Total GST(12%)"}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.gstInvoice)?_c('v-text-field',{attrs:{"readonly":"","value":_vm.GST_Percentage_total.GST_18,"type":"number","label":"Total GST(18%)"}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.gstInvoice)?_c('v-text-field',{attrs:{"readonly":"","value":_vm.GST_Percentage_total.GST_28,"type":"number","label":"Total GST(28%)"}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},nativeOn:{"click":function($event){_vm.transactionDialog = true}}},[_vm._v("Transaction Details")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","s12":"","md6":""}},[_c('v-select',{attrs:{"dense":"","readonly":_vm.isSummary,"items":[{
                          text: 'Cash',
                          value: 'Cash'
                        }, {
                          text: 'Bank Account',
                          value: 'Bank Account'
                        }, {
                          text: 'Cash & Bank Account',
                          value: 'CashAndBank Account'
                        }],"label":"Select Payment Type"},on:{"change":function($event){return _vm.resetAmounts()}},model:{value:(_vm.paymentType),callback:function ($$v) {_vm.paymentType=$$v},expression:"paymentType"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"readonly":_vm.isSummary,"type":"number","disabled":_vm.amountFromCashDisabled,"label":"Amount from Cash"},model:{value:(_vm.amountFromCash),callback:function ($$v) {_vm.amountFromCash=$$v},expression:"amountFromCash"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"readonly":_vm.isSummary,"type":"number","disabled":_vm.amountFromBankDisabled,"label":"Amount from Bank"},model:{value:(_vm.amountFromBank),callback:function ($$v) {_vm.amountFromBank=$$v},expression:"amountFromBank"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","label":"Paid Amount (in ₹)","readonly":"","prefix":""},model:{value:(_vm.paidAmount),callback:function ($$v) {_vm.paidAmount=$$v},expression:"paidAmount"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","label":"Remaining Amount (in ₹)","readonly":"","prefix":""},model:{value:(_vm.remainingAmount),callback:function ($$v) {_vm.remainingAmount=$$v},expression:"remainingAmount"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-select',{attrs:{"dense":"","readonly":_vm.isSummary,"items":[{
                          text: 'Due',
                          value: 'Debit'
                        }, {
                          text: 'Partial Paid',
                          value: 'Partial Paid'
                        }, {
                          text: 'Full Paid',
                          value: 'Credit'
                        }],"label":"Select Transaction type","disabled":!_vm.items.length},on:{"change":function($event){return _vm.resetAmounts()}},model:{value:(_vm.transactionType),callback:function ($$v) {_vm.transactionType=$$v},expression:"transactionType"}})],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":"","persistent":""},model:{value:(_vm.printDialog),callback:function ($$v) {_vm.printDialog=$$v},expression:"printDialog"}},[_c('v-card',{staticStyle:{"height":"fit-content"},attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Print an E-Way Bill")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.printDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('print-invoice',{attrs:{"invoiceData":_vm.invoiceDraft,"bank":_vm.bankById(_vm.selectedBank),"firm":_vm.firmById(_vm.selectedFirm),"seller":_vm.sellerById(_vm.selectedBuyer),"buyer":_vm.buyerById(_vm.selectedBuyer),"termsAndConditions":_vm.getTermsAndConditions(),"gstTotal":_vm.GST_Val_total}}),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1764:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('invoice-screen',{attrs:{"isSummary":"","invoiceData":_vm.invoiceData}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.0dc810cb6415d824e55d.js